import store from '../store';
import * as actions from '../actions';
import Renderer from './menu-object-renderer';
import AppRenderer from '../canvas/renderer';
import PostRenderer from './menu-object-post-renderer';
import CanvasRenderer from './renderer';
import util, { isValidString, removeMenuObjectPlaceholders } from '../util';
import History from './history';
import constants, {INLINE_LAYOUTS, priceColumns} from "../constants";
import {updateActiveFonts} from "./font";
import * as md5 from "md5";
import { updatePageBars, removePageBars } from './selection';
import tinycolor from 'tinycolor2';
import Interactable from "./interactable";
import $ from "jquery";
import {markAsModified} from "./mark-as-modified";
import canvas from "./index";
import designDomain from '../domain/designDomain';
import { addComponent, VIEWPORT_CENTER } from './component';
import {getPageZoom} from "./interactable-helpers";
import {setHasPosData} from "../actions";

const DOT_ERROR_MARGIN_NAME_MULTI_PRICE = 3;

const MENU_OBJECT = 'menu-object';

const NAME = 'name';
const TAG = 'tag';
const DESCRIPTION = 'description';
const PRICE = 'price';
const ITEMS = 'items';
const EXTRAS = 'extras';
const MODIFIERNAME = 'modifier-name';
const MODIFIERENTRYNAME = 'modifier-entry-name';
const MODIFIERENTRYPRICE = 'modifier-entry-price';
const MODIFIERDIVIDER = 'modifier-entry:not(:last-child)::after';
const BIN = 'bin';
const BINHEADER = 'bin-header';
const MONAME = 'mo-name';
const MONOTES = 'mo-notes';
const MOCONTENT = 'mo-content';
const PRICEENTRY = 'price-entry';
const PRICEDIVIDER = 'price-entry:not(.last)::after';
const FIRSTITEMPRICEDIVIDER = 'item:first-child .price-entry:not(.last)::after';
const RIGHT = 'right';

const ICON = 'icon';
const ICON_ENTRY = 'icon-entry';

const applyModes = {
  nameNotesStyle: 'name-notes-style',
  nameStyle: 'name-style',
  notesStyle: 'note-style',
  itemStyle: 'item-style',
  itemNameStyle: 'item-name-style',
  itemDescriptionStyle: 'item-description-style',
  itemPriceStyle: 'item-price-style',
  itemExtrasStyle: 'item-extras-style',
  itemIconsStyle: 'item-icons-style',
  modifiersStyle: 'modifiers-style',
  modifiersNameStyle: 'mod-group-name-style',
  modifiersEntryNameStyle: 'mod-name-style',
  modifiersEntryPriceStyle: 'mod-price-style',
  highlightStyle: 'highlight-style',
  tagStyle: 'item-tags',
  nameBorder: 'name-border',
  nameFill: 'name-fill',
  notesBorder: 'notes-border',
  border: 'border',
  fill: 'fill',
  priceBorder: 'price-border',
  columns: 'columns',
  nameSpacing: 'name-spacing',
  notesSpacing: 'notes-spacing',
  itemSpacing: 'item-spacing',
}

export const inlinePriceColumnLayouts = ['prices-right', 'prices-right-inline-top', 'bin-prices-right', 'bin-prices-right-header'];
const bottomAlignPriceColumnLayouts = ['prices-right-bottom', 'prices-right', 'bin-prices-right', 'bin-prices-right-header', 'prices-right-with-dot-leaders'];
const topAlignPriceColumnLayouts = ['prices-right-top', 'prices-right-inline-top', 'bin-price-column', 'bin-price-column-header'];
const priceLineLayouts = ['stacked', 'stacked-left', 'price-name-center', 'price-name-left', 'price-name-right', 'price-description-left', 'price-description-center', 'price-description-right', 'compact', 'compact-center'];

const letterIconStyleAttrs = ['font-family','color', 'font-weight',  'text-transform', 'font-style', 'text-decoration'];

class MenuItem {
  constructor(name, tag, description, prices, extras, bin, binHeader, icons, modifiers, objectID, groupID, mock) {
    this.name = name || '';
    this.tag = tag || '';
    this.description = description || '';

    this.prices = prices && prices.length > 0 ? prices : [{size: '', price: '', displayPrice: ''}];
    this.extras = extras || '';
    this.bin = bin || '';
    this.binHeader = binHeader || '';
    this.icons = icons || [];
    this.modifiers = modifiers || [];
    this.objectID = objectID || '';
    this.mock = mock === true;

    this.source = "";
    this.id = util.UUID.get();
    this.parentId = "";

    this.groupID = groupID || '';
    if (this.groupID === '') {
      this.groupID = objectID || '';
    }
  }
}

class MenuIcon {
  constructor(iconKey, type, fill, altText="", source="") {
    this.iconKey = iconKey || '';
    this.type = type || 'svg';
    this.fill = fill || '';
    this.altText = altText || '';
    this.source = source || '';
  }
}

class MenuObjectName {
  constructor(name) {
    this.moName = name || '';
  }
}

class MenuObjectNotes {
  constructor(notes) {
    this.moNotes = notes || '';
  }
}

class ItemModifier {
  constructor(name, entries) {
    this.name = name || '';
    this.entries = entries || [];
  }
}

class ItemModifierEntry {
  constructor(name, price, displayPrice) {
    this.name = name || '';
    this.price = price || '';
    this.displayPrice = displayPrice || '';
  }
}

function getDefaultMONamePadding() {
  const pageFontSize = $('#page-1').css('font-size');
  return `0px ${pageFontSize}`;
}

function getDefaultMONotesPadding() {
  const pageFontSize = $('#page-1').css('font-size');
  return `0px ${pageFontSize}`;
}

const getSelectBar = (resizable = true) => `
        <div class="bars">
            <span class="left"></span>
            <span class="right"></span>
            <span class="top"></span>
            <span class="btm"></span>
            ${resizable ? '<span class="res-left"></span>' : ''}
            ${resizable ? '<span class="res-right"></span>' : ''}
            ${resizable ? '<span class="btm-left"></span>' : ''}
            ${resizable ? '<span class="btm-right"></span>' : ''}
            ${resizable ? '<span class="top-left"></span>' : ''}
            ${resizable ? '<span class="top-right"></span>' : ''}
            <span class="edit-mo"><svg><use xlink:href="${constants.appPrefix + "/svg/icons.svg#app-icon-edit"}" /></svg></span>
        </div>
    `;
const isMenuObject = ($element) => $element?.attr('data-component') === MENU_OBJECT;

export const unescapeHtml = (html) => html
  .replace(/&amp;/g, '&')
  .replace(/&nbsp;/g, ' ')
  .replace(/&lt;/g, '<')
  .replace(/&gt;/g, '>')
  .replace(/&quot;/g, '"')
  .replace(/&#039;/g, "'")
  .replace(/<br>/g, '\n');

const getMenuItemContent = ($element) => {
  return $element.length ? getMenuItemContentText($element.html()) : "";
};

export const removeTrailingZeroes = (priceString) => {
  if (!priceString) return;
  let toReturn = priceString;
  if (priceString.includes('.')) {
    toReturn = toReturn.replace(/\.?0+$/, '');
  }
  return toReturn;
}

const getMenuItemContentText = (text, hideTrailingZeroes = false) => {
  text = unescapeHtml(text).trim();
  if (hideTrailingZeroes) {
    text = removeTrailingZeroes(text);
  }
  return text;
}

function formatPrice(price) {
  if (price === null || price === undefined) {
    return "";
  }
  return price.toFixed(2);
}

function getMIPrice(p, locationId) {
  if (locationId && p.locationOverride) {
    const prices = JSON.parse(p.locationOverride);
    if (prices[locationId]) {
      return formatPrice(prices[locationId]);
    }
  }
  return p.price;
}

export function addDisplayPrices(items, hideTrailingZeroes, locationId) {
  if (hideTrailingZeroes) {
    items.forEach(i => {
      i.prices.forEach(p => {
        if (typeof p !== 'object') {
          p = JSON.parse(p);
        }
        p.displayPrice = removeTrailingZeroes(getMIPrice(p, locationId));
      })
    })
  } else {
    items.forEach(i => {
      i.prices.forEach(p => {
        if (typeof p !== 'object') {
          p = JSON.parse(p);
        }
        p.displayPrice = getMIPrice(p, locationId);
      })
    })
  }
  return items;
}

function getPriceAndSizeContent($element, hideZeroes) {
  const pv = $element.attr('data-pv');
  const ps = $element.attr('data-ps');

  let price = $element.html();
  let displayPrice = hideZeroes ? removeTrailingZeroes($element.html()) : $element.html();
  let size = '';
  if (isValidString(pv) && isValidString(ps)) {
    price = getMenuItemContentText(pv);
    displayPrice = getMenuItemContentText(pv, hideZeroes);
    size = getMenuItemContentText(ps);
  }
  return JSON.stringify({price, displayPrice, size});
}

export function setInitColors($comp, fontColor) {
  ['name', 'tag', 'description', 'price', 'extras'].forEach(function (cat) {
    patchStyles($comp, {
      type: cat,
      key: 'color',
      value: fontColor
    })
  })
}

export function spellCheck(key, value){
  const $objects = $('.menu-object');

  $objects.each(function () {
    const $this = $(this);
    const items = getMenuItems($this);

    const moName = $this.find(".mo-name").html() ?? "";
    if (moName.indexOf(key) > -1) {
      $this.find(".mo-name").html(moName.replace(key, value));
    }

    items.forEach(item => {
      if (item.name.indexOf(key) > -1) {
        item.name = item.name.replace(key, value);
      }

      if (item.description && item.description.indexOf(key) > -1) {
        item.description = item.description.replace(key, value);
      }

      if (item.note && item.note.indexOf(key) > -1) {
        item.note = item.note.replace(key, value);
      }
    });
    updateContent($this, items);
  });
}

export function getMenuItems($comp) {
  const items = [];
  const hideZeroes = $comp.attr('data-hide-trailing-zeroes') && $comp.attr('data-hide-trailing-zeroes') === 'true';
  if ($comp) {
    $comp.find('.item').each(function () {
      const $item = $(this);

      const $name = $item.find('.name');
      let name = "";
      if ($name.find(".dots").length === 0) {
        name = getMenuItemContent($name);
      } else {
        const $clone = $name.clone();
        $clone.find(".dots").remove();
        name = getMenuItemContent($clone);
      }

      const $tag = $item.find('.tag');
      let tag = "";
      if ($tag) {
        tag = getMenuItemContent($tag);
      }

      const $description = $item.find('.description');
      let description = "";
      if ($description.find(".dots").length === 0) {
        description = getMenuItemContent($description);
      } else {
        const $clone = $description.clone();
        $clone.find(".dots").remove();
        description = getMenuItemContent($clone);
      }

      const $extras = $item.find('.extras');
      const extras = $extras.length > 0 ? getMenuItemContent($extras) : '';

      const $bin = $item.find('.bin');
      const bin = $bin.length > 0 ? getMenuItemContent($bin) : '';

      const $binHeader = $item.find('.bin-header');
      const binHeader = $binHeader.length > 0 ? getMenuItemContent($binHeader) : '';

      const prices = [];
      $item.find('.price-entry').each(function () {
        prices.push(getPriceAndSizeContent($(this), hideZeroes));
      });

      const icons = [];
      $item.find('.icon-entry').each(function () {
        const $this = $(this);
        let icon = new MenuIcon(
          $this.attr('icon-key'),
          $this.attr('icon-type'),
          $this.attr('icon-fill'),
          $this.attr('alt') ? $this.attr('alt') :
            $this.attr('aria-label') ? $this.attr('aria-label') :
            '',
          $this.attr('icon-source'));
        icons.push(icon);
      });

      let modifiers = [];
      $item.find('.modifier').each(function() {
        const $thisMod = $(this);
        const modName = $thisMod.find('.modifier-name').text();
        let modEntries = [];
        $thisMod.find('.modifier-entry').each(function() {
          const $thisEntry = $(this);
          const entryName = $thisEntry.find('.modifier-entry-name').text().trim();
          const displayPrice = removeTrailingZeroes($thisEntry.find('.modifier-entry-price').text().trim()) || '';
          const entryPrice = $thisEntry.find('.modifier-entry-price').attr('data-pv') || '';
          const thisEntry = new ItemModifierEntry(entryName, entryPrice, hideZeroes ? displayPrice : entryPrice);
          modEntries.push(thisEntry);
        })
        let mod = new ItemModifier(modName, modEntries);
        modifiers.push(mod);
      })

      const instance = new MenuItem(name, tag, description, prices, extras, bin, binHeader, icons, modifiers, "", "", $item.attr("data-mock") === "true");
      instance.source = $item.attr("data-source") ?? "mhm";
      if ($item.attr("data-id")) {
        instance.id = $item.attr("data-id");
      } else {
        const newId = util.UUID.get();
        instance.id = newId;
        $item.attr('data-id', newId);
      }
      instance.parentId = $comp.attr("data-id");
      items.push(instance);
    });
  }
  return items;
}

export function getMenuItemIcons($comp) {
  const items = [];
  if ($comp) {
    $comp.find('.item').each(function () {
      const $item = $(this);
      const icons = [];
      $item.find('.icon-entry').each(function () {
        const $icon = $(this);
        let icon = new MenuIcon(
          $icon.attr('icon-key'),
          $icon.attr('icon-type'),
          $icon.attr('icon-fill'),
          $icon.attr('alt') ? $icon.attr('alt') : '',
          $icon.attr('icon-source'),
        );
        icons.push(icon);
      });
      items.push({icons: icons});
    });
  }
  return items;
}

function getFirstMenuItemConfig() {
  const $first = $('.menu-object').first();
  const styles = getStyles($first);
  if (styles) {
    if (styles['items']) {
      delete styles['items'];
    }
    if (styles['item'] && styles['item']['width']) {
      delete styles['item']['width'];
    }
  }
  const layout = $first.attr('data-layout');
  const showMenuTag = $first.attr('data-show-tag');
  const tagLayout = $first.attr('data-tag-layout');
  const moNameBackground = $first.attr('data-mo-name-color') ? $first.attr('data-mo-name-color').replaceAll('"', "&quot;") : "";
  const hidePrices = $first.attr('data-hide-prices') ? $first.attr('data-hide-prices') === "true" : false;
  const hideTrailingZeroes = $first.attr('data-hide-trailing-zeroes') ? $first.attr('data-hide-trailing-zeroes') === "true" : false;
  const inlineExtras = $first.attr('data-inline-extras') ? $first.attr('data-inline-extras') === "true" : false;
  const priceBorder = $first.attr('data-price-border') ? $first.attr('data-price-border') : 'none';
  const iconPosition = $first.attr('data-icon-position') ? $first.attr('data-icon-position') : 'name';
  const showModifiers = $first.attr('data-show-modifiers') ? $first.attr('data-show-modifiers') : false;
  const modifierLayout = $first.attr('data-modifier-layout') ? $first.attr('data-modifier-layout') : 'in-line';

  return styles ? JSON.stringify({ styles, 'layout': layout, 'show-menu-tag': showMenuTag, 'tag-layout': tagLayout, 'mo-name-color': moNameBackground, 'hide-prices': hidePrices, 'hide-trailing-zeroes': hideTrailingZeroes, 'inline-extras': inlineExtras, 'price-border': priceBorder, 'icon-position': iconPosition, 'show-modifiers': showModifiers, 'modifier-layout': modifierLayout }) : '';
}

function getStyles($element) {
  if ($element.length > 1) {
    $element = $element.eq(0);
  }
  const text = $element?.find('.config').text();
  const config = text ? JSON.parse(text) : undefined;
  return config?.styles;
}

function patchLineHeight(styles, value) {
  styles[NAME]['line-height'] = value;
  styles[TAG]['line-height'] = value;
  styles[DESCRIPTION]['line-height'] = value;
  styles[PRICE]['line-height'] = value;
  styles[EXTRAS]['line-height'] = value;
  if (styles[BIN]) styles[BIN]['line-height'] = value;
  if (styles[BINHEADER]) styles[BINHEADER]['line-height'] = value;
}

const updateStyleSheet = ($comp, styles) => {
  const sheet = document.createElement('style');
  sheet.innerHTML = styles;

  $comp.find('style').remove();
  $comp.append(sheet);
};

function computeStyleSet(id, target, rules) {
  const set = rules[target] || {};
  let rule = '';
  const keys = Object.keys(set);
  if (keys.includes('border')) {
    keys.splice(keys.indexOf('border'), 1);
    keys.push('border');
  }
  keys.forEach((key) => {
    rule += `${key}:${set[key]};`;
  });
  return `#${id} .${target}{${rule}}`;
}

function computeItemHighlightStyleSet(id, rules) {
  let highlightRuleKeys = [];
  for (var key in rules) {
    if (key.startsWith('item.highlighted')) {
      if (!highlightRuleKeys.includes(key)) {
        highlightRuleKeys.push(key);
      }
    }
  }

  let retrule = '';
  highlightRuleKeys.forEach(rk => {
    let parts = rk.split('#');
    let rulesForId = '';
    Object.keys(rules[rk]).forEach(key => {
      rulesForId += `${key}:${rules[rk][key]};`;
    })
    if (rk.indexOf('.self') > 0) {
      retrule += `#${id} .item.highlighted[data-highlight-id="${parts[1]}"]{${rulesForId}}`;
    } else {
      retrule += `#${id} .item.highlighted[data-highlight-id="${parts[1]}"]:before{${rulesForId}}`
    }
  })

  return retrule;
}

function computePriceBorderStyleSet(id, rules) {
  let retrule = '';
  Object.keys(rules).forEach(key => {
    if (key.includes('.right::before')) {
      const set = rules[key];
      let rulesForKey = '';
      Object.keys(set).forEach(setKey => {
        rulesForKey += `${setKey}:${set[setKey]};`;
      })
      retrule += `#${id} .${key} {${rulesForKey}}`;
    }
  });
  return retrule;
}

function computeIconStyleSet(id, rules) {
  const setIcon = rules[NAME] || {};
  const setIconEntry = rules[ICON_ENTRY] || (rules[id] ? rules[id][ICON_ENTRY] : {}) || {};
  const setIconAll = rules[ICON] || (rules[id] ? rules[id][ICON] : {}) || {};
  let ruleIcon = `vertical-align: baseline;`;
  /*if (setIcon['line-height']) {
    ruleIcon += `line-height:${setIcon['line-height']};`;
  }*/
  if (setIconAll['font-size']) {
    ruleIcon += `font-size:${setIconAll['font-size']};`;
  } else {
    ruleIcon += `font-size:${setIcon['font-size']};`
  }

  let ruleIconEntry = 'display: inline-block;vertical-align: text-top;text-align: center;';
  ruleIconEntry += `height:1em;`;
  ruleIconEntry += `width:1em;`;
  ruleIconEntry += `line-height:1em;`;
  ruleIconEntry += `fill:${setIconEntry['color']}; color:${setIconEntry['color']};`;

  letterIconStyleAttrs.forEach(attr => {
    if (setIconEntry[attr]) {
      ruleIconEntry += `${attr}:${setIconEntry[attr]};`;
    }
  })

  return `#${id} .${ICON}{${ruleIcon}}#${id} .${ICON_ENTRY}{${ruleIconEntry}}`;
}

const buildCssRules = (id, rules, numPrices) => {
  const singlePriceStyles = numPrices > 0 ? [...Array(numPrices).keys()].map((p) => {
    return computeStyleSet(id, `price-entry:nth-child(${p+1})`, rules);
  }).join(' ') : '';

  return `${computeStyleSet(id, 'item', rules)} 
    ${computeStyleSet(id, NAME, rules)} 
    ${computeIconStyleSet(id, rules)} 
    ${computeStyleSet(id, TAG, rules)} 
    ${computeStyleSet(id, DESCRIPTION, rules)} 
    ${computeStyleSet(id, PRICE, rules)}
    ${computeStyleSet(id, PRICEENTRY, rules)} 
    ${singlePriceStyles}
    ${computeStyleSet(id, PRICEDIVIDER, rules)} 
    ${computeStyleSet(id, FIRSTITEMPRICEDIVIDER, rules)} 
    ${computeStyleSet(id, ITEMS, rules)} 
    ${computeStyleSet(id, EXTRAS, rules)}
    ${computeStyleSet(id, MODIFIERNAME, rules)}
    ${computeStyleSet(id, MODIFIERENTRYNAME, rules)}
    ${computeStyleSet(id, MODIFIERENTRYPRICE, rules)}
    ${computeStyleSet(id, MODIFIERDIVIDER, rules)}
    ${computeStyleSet(id, BIN, rules)}
    ${computeStyleSet(id, BINHEADER, rules)}
    ${computeStyleSet(id, MONAME, rules)} 
    ${computeStyleSet(id, MONOTES, rules)} 
    ${computeStyleSet(id, MOCONTENT, rules)}
    ${computeStyleSet(id, RIGHT, rules)}
    ${computeItemHighlightStyleSet(id, rules)}
    ${computePriceBorderStyleSet(id, rules)}
    ${computeStyleSet(id, 'item.highlighted>*', rules)}`;
}

function applyLayoutToAll($element, applyMode = '', applyToElements = []) {
  const $menuObjects = applyToElements.length > 0  ? applyToElements : $('.menu-object');
  if (applyMode === applyModes.columns) {
    const numColumns = parseInt($element.attr('data-num-columns')) || 1;
    const columnGap = $element.attr('data-column-gap') !== undefined ? parseInt($element.attr('data-column-gap')) : 1;
    const columnWidths = $element.attr('data-column-widths') !== undefined ? JSON.parse($element.attr('data-column-widths')) : [];

    const oldNumColumns = {};
    const oldColumnGaps = {};
    const newNumColumns = {};
    const newColumnGaps = {};
    const oldColumnWidths = {};
    const newColumnWidths = {};

    $menuObjects.each(function() {
      const $this = $(this);
      const thisNumColumns = parseInt($this.attr('data-num-columns')) || 1;
      const thisColumnGap = $this.attr('data-column-gap') !== undefined ? parseInt($this.attr('data-column-gap')) : 0;
      const thisColumnWidths = $this.attr('data-column-widths') !== undefined ? JSON.parse($this.attr('data-column-widths')) : [];

      oldNumColumns[$this.attr('id')] = thisNumColumns;
      oldColumnGaps[$this.attr('id')] = thisColumnGap;
      oldColumnWidths[$this.attr('id')] = thisColumnWidths;
      newNumColumns[$this.attr('id')] = numColumns;
      newColumnGaps[$this.attr('id')] = columnGap;
      newColumnWidths[$this.attr('id')] = columnWidths;
    });

    const itemsFromSelectedEl = getMenuItems($element);
    store.dispatch(actions.setMenuObjectItems(itemsFromSelectedEl));

    function apply(numColumns, columnGaps, columnWidths) {
      $menuObjects.each(function () {
        const $this = $(this);
        const thisNum = numColumns[$this.attr('id')];
        const thisGap = columnGaps[$this.attr('id')];
        const thisWidths = columnWidths[$this.attr('id')];

        setColumns($this, thisNum, true);
        util.nextTick(() => {
          setColumnGap($this, thisGap, true);
          setColumnWidths($this, thisWidths, true);
        })
      });
    }

    const undo = () => apply(oldNumColumns, oldColumnGaps, oldColumnWidths);
    const redo = () => apply(newNumColumns, newColumnGaps, newColumnWidths);

    redo();
    History.push(undo, redo, 'Apply column settings to all');
  } else {
    const layout = $element.attr('data-layout');

    const oldLayouts = {};
    const newLayouts = {};

    $menuObjects.each(function() {
      const $this = $(this);
      oldLayouts[$this.attr('id')] = $this.attr('data-layout');
      newLayouts[$this.attr('id')] = layout;
      updateLayout($this, layout);
    });

    const itemsFromSelectedEl = getMenuItems($element);
    store.dispatch(actions.setMenuObjectItems(itemsFromSelectedEl));

    function apply(layouts) {
      $menuObjects.each(function () {
        const $this = $(this);
        const layout = layouts[$this.attr('id')];
        if (layout) {
          updateLayout($this, layout);
        }
      });
    }

    const undo = () => apply(oldLayouts);
    const redo = () => apply(newLayouts);

    redo();
    History.push(undo, redo, 'Apply layout to all');
  }
}

const applyToAll = ($element, applyMode = '', applyToElements = []) => {
  const $menuObjects = applyToElements.length > 0  ? applyToElements : $('.menu-object');
  const styles = getStyles($element);

  const oldStyles = {};
  const newStyles = {};

  const oldScales = {};
  const newScales = {};
  const originalScale = Interactable.of($element).getScale();

  const oldDataMONameColor = $element.attr('data-mo-name-color') || '';

  $menuObjects.each(function () {
    const $this = $(this);
    const id = $this.attr('id');
    const moOldStyles = getStyles($this);
    let moNewStyles =  {...moOldStyles};

    let itemStyleAttrs = ['font-family', 'font-size', 'text-decoration', 'font-style', 'font-weight', 'text-transform', 'color'];
    let moNaNStyleAttrs = ['font-family', 'font-size', 'text-decoration', 'font-style', 'font-weight', 'text-transform', 'color', 'text-align'];
    let itemSpacingAttrs = [
      ['item', 'line-height'],
      ['item', 'margin-bottom'],
      ['name', 'letter-spacing'],
      ['name', 'line-height'],
      ['description', 'line-height'],
      ['tag', 'line-height'],
      ['bin-header', 'line-height'],
      ['bin', 'line-height'],
      ['extras', 'margin-top'],
      ['price-entry', 'margin-right']
    ];
    let moNameSpacingAttrs = ['letter-spacing', 'line-height', 'margin-bottom'];
    let moNotesSpacingAttrs = ['letter-spacing', 'line-height', 'margin-bottom'];
    let moBorderAttrs = ['border', 'border-radius'];
    let moFillAttrs = ['background'];
    let moNameFillAttrs = ['background', 'border-radius'];
    let moNameBorderAttrs = ['border', 'border-bottom', 'border-radius'];
    let moNotesBorderAttrs = ['border-bottom'];

    function createEmptyStyle(key) {
      if (!moNewStyles[key]) {
        moNewStyles[key] = {};
      }
    }

    function addStyle(key, attr) {
      if (styles[key] && styles[key][attr]) {
        moNewStyles[key][attr] = styles[key][attr];
      }
    }

    if (applyMode === applyModes.nameNotesStyle) {
      createEmptyStyle(MONAME);
      moNewStyles[MONAME]['padding'] = getDefaultMONamePadding();
      moNaNStyleAttrs.forEach((attr) => {
        addStyle(MONAME, attr);
      })
      createEmptyStyle(MONOTES);
      moNewStyles[MONOTES]['padding'] = getDefaultMONotesPadding();
      moNaNStyleAttrs.forEach((attr) => {
        addStyle(MONOTES, attr);
      })
    } else if (applyMode === applyModes.nameStyle) {
      createEmptyStyle(MONAME);
      moNewStyles[MONAME]['padding'] = getDefaultMONamePadding();
      moNaNStyleAttrs.forEach((attr) => {
        addStyle(MONAME, attr);
      })
    } else if (applyMode === applyModes.notesStyle) {
      if (!moNewStyles[MONOTES]) {
        moNewStyles[MONOTES] = {};
      }
      moNewStyles[MONOTES]['padding'] = getDefaultMONotesPadding();
      moNaNStyleAttrs.forEach((attr) => {
        addStyle(MONOTES, attr);
      })
    } else if (applyMode === applyModes.itemStyle) {
      let keys = [NAME, DESCRIPTION, PRICE, EXTRAS, BIN, BINHEADER, ICON];
      Object.keys(styles).forEach(newKey => {
        if (newKey.includes('price-entry:nth-child')) {
          keys.push(newKey);
        }
      })
      keys.forEach((key) => {
        createEmptyStyle(key);
        itemStyleAttrs.forEach((attr) => {
          addStyle(key, attr);
        })
        if (key.includes('price-entry:nth-child')) {
          addStyle(key, 'align-items');
        }
      })
      createEmptyStyle(PRICEDIVIDER);
      addStyle(PRICEDIVIDER, 'content');

      if (styles['icon-entry'] && (styles['icon-entry']['color'] || styles['icon-entry']['font-family'])) {
        createEmptyStyle(ICON_ENTRY);
        addStyle(ICON_ENTRY, 'color');
        letterIconStyleAttrs.forEach(attr => {
          addStyle(ICON_ENTRY, attr);
        })
      }
    } else if (applyMode === applyModes.itemNameStyle) {
      createEmptyStyle(NAME);
      itemStyleAttrs.forEach((attr) => {
        addStyle(NAME, attr);
      })
    } else if (applyMode === applyModes.itemDescriptionStyle) {
      createEmptyStyle(DESCRIPTION);
      itemStyleAttrs.forEach((attr) => {
        addStyle(DESCRIPTION, attr);
      })
    } else if (applyMode === applyModes.itemPriceStyle) {
      let keys = [];
      Object.keys(styles).forEach(newKey => {
        if (newKey.includes('price-entry:nth-child')) {
          keys.push(newKey);
        }
      })
      keys.forEach((key) => {
        createEmptyStyle(key);
        itemStyleAttrs.forEach((attr) => {
          addStyle(key, attr);
        })
        if (key.includes('price-entry:nth-child')) {
          addStyle(key, 'align-items');
        }
      })
      createEmptyStyle(PRICEDIVIDER);
      addStyle(PRICEDIVIDER, 'content');
    } else if (applyMode === applyModes.itemExtrasStyle) {
      createEmptyStyle(EXTRAS);
      itemStyleAttrs.forEach((attr) => {
        addStyle(EXTRAS, attr);
      })
    } else if (applyMode === applyModes.itemIconsStyle) {
      createEmptyStyle(ICON);
      itemStyleAttrs.forEach((attr) => {
        addStyle(ICON, attr);
      })

      if (styles['icon-entry'] && (styles['icon-entry']['color'] || styles['icon-entry']['font-family'])) {
        createEmptyStyle(ICON_ENTRY);
        addStyle(ICON_ENTRY, 'color');
        letterIconStyleAttrs.forEach(attr => {
          addStyle(ICON_ENTRY, attr);
        })
      }
    } else if (applyMode === applyModes.modifiersStyle) {
      let keys = [MODIFIERNAME, MODIFIERENTRYNAME, MODIFIERENTRYPRICE];
      keys.forEach((key) => {
        createEmptyStyle(key);
        itemStyleAttrs.forEach((attr) => {
          addStyle(key, attr);
        })
        if (key.includes('price-entry:nth-child')) {
          addStyle(key, 'align-items');
        }
      })
      createEmptyStyle(MODIFIERDIVIDER);
      addStyle(MODIFIERDIVIDER, 'content');
    } else if (applyMode === applyModes.modifiersNameStyle) {
      createEmptyStyle(MODIFIERNAME);
      itemStyleAttrs.forEach((attr) => {
        addStyle(MODIFIERNAME, attr);
      })
    } else if (applyMode === applyModes.modifiersEntryNameStyle) {
      createEmptyStyle(MODIFIERENTRYNAME);
      itemStyleAttrs.forEach((attr) => {
        addStyle(MODIFIERENTRYNAME, attr);
      })
    } else if (applyMode === applyModes.modifiersEntryPriceStyle) {
      createEmptyStyle(MODIFIERENTRYPRICE);
      itemStyleAttrs.forEach((attr) => {
        addStyle(MODIFIERENTRYPRICE, attr);
      })
    } else if (applyMode === applyModes.highlightStyle) {
      const selectedHighlightId = store.getState().lastSelectedHighlightId;
      $this.find('.item.highlighted').each(function() {
        const $item = $(this);
        const highlightId = $item.attr('data-highlight-id');
        ['border', 'border-radius', 'background', 'margin'].forEach(attr => {
          if (styles[`item.highlighted#${selectedHighlightId}`] && styles[`item.highlighted#${selectedHighlightId}`][attr] !== undefined) {
            moNewStyles[`item.highlighted#${highlightId}`][attr] = styles[`item.highlighted#${selectedHighlightId}`][attr];
          }
        })
      })
    } else if (applyMode === applyModes.nameSpacing) {
      createEmptyStyle(MONAME);
      moNewStyles[MONAME]['padding'] = getDefaultMONamePadding();
      moNameSpacingAttrs.forEach((attr) => {
        addStyle(MONAME, attr);
      })
    } else if (applyMode === applyModes.notesSpacing) {
      createEmptyStyle(MONAME);
      moNewStyles[MONOTES]['padding'] = getDefaultMONotesPadding();
      moNotesSpacingAttrs.forEach((attr) => {
        addStyle(MONOTES, attr);
      })
    } else if (applyMode === applyModes.border) {
      createEmptyStyle(MOCONTENT);
      moBorderAttrs.forEach((attr) => {
        addStyle(MOCONTENT, attr);
      })
    } else if (applyMode === applyModes.fill) {
      createEmptyStyle(MOCONTENT);
      moFillAttrs.forEach((attr) => {
        addStyle(MOCONTENT, attr);
      })
    } else if (applyMode === applyModes.nameFill) {
      createEmptyStyle(MONAME);
      moNameFillAttrs.forEach((attr) => {
        addStyle(MONAME, attr);
      })
    } else if (applyMode === applyModes.nameBorder) {
      createEmptyStyle(MONAME);
      moNameBorderAttrs.forEach((attr) => {
        addStyle(MONAME, attr);
      })
    } else if (applyMode === applyModes.notesBorder) {
      createEmptyStyle(MONOTES);
      moNotesBorderAttrs.forEach((attr) => {
        addStyle(MONOTES, attr);
      })
    } else if (applyMode === applyModes.itemSpacing) {
      itemSpacingAttrs.forEach((pair) => {
        createEmptyStyle(pair[0]);
        addStyle(pair[0], pair[1]);
      })
    } else if (applyMode === applyModes.tagStyle) {
      createEmptyStyle(TAG);
      itemStyleAttrs.forEach((attr) => {
        addStyle(TAG, attr);
      })
    }

    newStyles[id] = moNewStyles;
    oldStyles[id] = moOldStyles;

    oldScales[id] = Interactable.of($this).getScale();
    newScales[id] = originalScale;
  });

  const itemsFromSelectedEl = getMenuItems($element);
  store.dispatch(actions.setMenuObjectItems(itemsFromSelectedEl));

  function apply(styles, scales) {
    if (applyMode === applyModes.itemStyle || applyMode === applyModes.itemIconsStyle) {
      removeIndividualIconColors();
    }
    $menuObjects.each(function () {
      const $this = $(this);
      const currentStyles = styles[$this.attr('id')];
      if (currentStyles) {
        overwriteStyles($this, currentStyles);
      }
      if (applyMode === applyModes.itemStyle) {
        const iconLayout = $element.attr('icon-layout');
        const iconsInDescription = $element.attr('data-icons-in-description') === 'true' || false;
        const iconPosition = $element.attr('data-icon-position') ? $element.attr('data-icon-position') : 'name';
        const hidePrices = $element.attr('data-hide-prices') === 'true' || false;
        const hideTrailingZeroes = $element.attr('data-hide-trailing-zeroes') === 'true' || false;
        const inlineExtras = $element.attr('data-inline-extras') === 'true' || false;
        const priceDivider = $element.attr('data-price-divider') || '';
        const thisLayout = $this.attr('data-layout');
        $this.attr('icon-layout', iconLayout);
        $this.attr('data-icons-in-description', iconsInDescription);
        $this.attr('data-icon-position', iconPosition === 'price' && priceColumns.includes(thisLayout) ? 'name' : iconPosition);
        $this.attr('data-hide-prices', hidePrices);
        $this.attr('data-hide-trailing-zeroes', hideTrailingZeroes);
        $this.attr('data-inline-extras', inlineExtras);
        if ($this.attr('data-price-divider') !== priceDivider) {
          updatePriceDivider($this, priceDivider);
        }
        fixPriceBorder($element);

        const i = Interactable.of($this);
        i.setScale(scales[$this.attr('id')]);
        i.refreshPosition();
      }
      if (applyMode === applyModes.itemPriceStyle) {
        const hidePrices = $element.attr('data-hide-prices') === 'true' || false;
        const hideTrailingZeroes = $element.attr('data-hide-trailing-zeroes') === 'true' || false;
        const priceDivider = $element.attr('data-price-divider') || '';
        $this.attr('data-hide-prices', hidePrices);
        $this.attr('data-hide-trailing-zeroes', hideTrailingZeroes);
        if ($this.attr('data-price-divider') !== priceDivider) {
          updatePriceDivider($this, priceDivider);
        }
        fixPriceBorder($element);
        const i = Interactable.of($this);
        i.setScale(scales[$this.attr('id')]);
        i.refreshPosition();
      }
      if (applyMode === applyModes.itemIconsStyle) {
        const thisLayout = $this.attr('data-layout');
        const iconLayout = $element.attr('icon-layout');
        const iconsInDescription = $element.attr('data-icons-in-description') === 'true' || false;
        const iconPosition = $element.attr('data-icon-position') ? $element.attr('data-icon-position') : 'name';
        $this.attr('icon-layout', iconLayout);
        $this.attr('data-icons-in-description', iconsInDescription);
        $this.attr('data-icon-position', iconPosition === 'price' && priceColumns.includes(thisLayout) ? 'name' : iconPosition);
        const i = Interactable.of($this);
        i.setScale(scales[$this.attr('id')]);
        i.refreshPosition();
      }
      if (applyMode === applyModes.itemExtrasStyle) {
        const inlineExtras = $element.attr('data-inline-extras') === 'true' || false;
        $this.attr('data-inline-extras', inlineExtras);
      }
      if (applyMode === applyModes.modifiersStyle) {
        const modifierLayout = $element.attr('data-modifier-layout');
        const showModifiers = $element.attr('data-show-modifiers') === 'true';
        const modifierDivider = $element.attr('data-modifier-divider') || '';
        if ($this.attr('data-modifier-layout') !== modifierLayout) {
          updateModifierLayout($this, modifierLayout);
        }
        $this.attr('data-show-modifiers', showModifiers);
        if ($this.attr('data-modifier-divider') !== modifierDivider) {
          updateModifierDivider($this, modifierDivider);
        }
      }
      if (applyMode === applyModes.nameFill) {
        $this.attr('data-mo-name-color', oldDataMONameColor);
      }
      if (applyMode === applyModes.priceBorder) {
        const priceBorder = $element.attr('data-price-border') || 'none';
        $this.attr('data-price-border', priceBorder);
      }
      if (applyMode === applyModes.border || applyMode === applyModes.priceBorder) {
        if ($element.attr('data-price-border')) {
          fixPriceBorder($this);
        }
      }
      if (applyMode === applyModes.tagStyle) {
        const useTags = $element.attr('data-show-tag');
        const tagLayout = $element.attr('data-tag-layout');
        $this.attr('data-show-tag', useTags);
        $this.attr('data-tag-layout', tagLayout);
      }
      if ([
           applyModes.itemStyle,
           applyModes.itemPriceStyle,
           applyModes.itemExtrasStyle,
           applyModes.itemIconsStyle,
           applyModes.modifiersStyle,
           applyModes.tagStyle,
           applyModes.priceBorder,
           applyModes.nameFill
          ].includes(applyMode)) {
        updateContent($this, getMenuItems($this), true, false, false);
      }
    });
  }

  const undo = () => apply(oldStyles, oldScales);
  const redo = () => apply(newStyles, newScales);

  redo();
  History.push(undo, redo, 'Apply to all');
};

export function overwriteStyles($element, styles, fixHeights = true) {
  $element.find('.config').text(JSON.stringify({styles: styles}));
  updateStyleSheet($element, buildCssRules($element.attr('id'), styles, getNumPrices(getMenuItems($element))));
  util.nextTick(() => setHeights($element));

  if (fixHeights) {
    if (constants.APPLY_LINE_HEIGHT_PATCH) {
      fixDots($element);
      fixLineHeights($element);
    } else {
      resetLineHeightsStandalone();
    }
  }
}

const patchStyles = ($element, patch, checkHeightAfter=true, history=true, allowFixDots=true) => {
  const $elements = Array.isArray($element) ? $element : [$element];
  const styles = $elements.map($element => getStyles($element));
  const oldStyles = [...styles];

  let isChange = false;

  styles.forEach(style => {
    // Handle column-specific width patches
    if (patch.type.startsWith('item:nth-child(') && patch.key === 'width') {
      style[patch.type] = style[patch.type] || {};

      style[patch.type][patch.key] = patch.value;
      isChange = true;
      // const itemNum = parseInt(patch.type.match(/\((\d+)\)/)[1]);
      // const numColumns = parseInt($element.attr('data-num-columns')) || 1;
      // const totalItems = $element.find('.item').length;
      // const itemsPerColumn = Math.ceil(totalItems / numColumns);

      // // Calculate which column this item belongs to
      // const columnIndex = Math.floor((itemNum - 1) / itemsPerColumn);

      // // Calculate start and end items for this column
      // const startItem = columnIndex * itemsPerColumn + 1;
      // const endItem = Math.min((columnIndex + 1) * itemsPerColumn, totalItems);

      // // Create style rules for all items in this column
      // for (let i = startItem; i <= endItem; i++) {
      //   const itemSelector = `item:nth-child(${i})`;
      //   style[itemSelector] = style[itemSelector] || {};
      //   if (style[itemSelector][patch.key] !== patch.value) {
      //     style[itemSelector][patch.key] = patch.value;
      //     isChange = true;
      //   }
      // }
    } else {
      // Original behavior for non-column-specific styles
      style[patch.type] = style[patch.type] || {};
      if (style[patch.type][patch.key] !== patch.value) {
        style[patch.type][patch.key] = patch.value;
        isChange = true;
      }
    }
  });

  if (!isChange) {
    return;
  }

  if (patch.type === 'item' && patch.key === 'line-height') {
    styles.forEach(style => {
      patchLineHeight(style, patch.value);
    });
  }

  const update = (newStyles) => {
    $elements.forEach(($element, idx) => {
      $element.find('.config').text(JSON.stringify({styles: newStyles[idx]}));
      updateStyleSheet($element, buildCssRules($element.attr('id'), newStyles[idx], getNumPrices(getMenuItems($element))));

      if (patch.key === 'font-family') {
        updateActiveFonts();
      }

      if (patch.key === 'line-height') {
        util.nextTick(() => setHeights($element));
      }

      if (patch.type === 'item' && patch.key === 'margin-bottom') {
        util.nextTick(() => updatePriceBorder($element));
      }

      if (patch.type === MODIFIERENTRYNAME) {
        const modifierChar = $element.attr('data-modifier-divider');
        if (modifierChar) {
          util.nextTick(() => updateModifierDivider($element, modifierChar));
        }
      }

      // Handle column-specific width updates
      if (patch.type.startsWith('item:nth-child(') && patch.key === 'width') {
        const columnWidths = JSON.parse($element.attr('data-column-widths') || '[]');
        const columnIndex = parseInt(patch.type.match(/\((\d+)\)/)[1]) - 1;

        // Extract percentage from calc expression
        const percentageMatch = patch.value.match(/calc\((\d+(?:\.\d+)?)%/);
        if (percentageMatch && columnIndex >= 0) {
          const percentage = parseFloat(percentageMatch[1]);
          columnWidths[columnIndex] = percentage;
          // $element.attr('data-column-widths', JSON.stringify(columnWidths));
          // Apply width directly to the column
          const $items = $element.find('.items .item');
          if ($items.length > columnIndex) {
            $items.eq(columnIndex).css('width', patch.value);
          }
        }
      } else if (patch.type === 'bin') {
        util.nextTick(() => {
          const items = getMenuItems($element);
          updateContent($element, items);
        })
      } else if (constants.APPLY_LINE_HEIGHT_PATCH) {
        if ($element.attr('data-dots') === "true" && allowFixDots) {
          fixDots($element);
          util.nextTick(() => {
            fixLineHeights($element);
          });
        } else {
          fixLineHeights($element, true);
        }
      } else {
        resetLineHeightsStandalone();
      }
    });

    store.dispatch(actions.setMenuObjectStyles(newStyles[0]));

    if (checkHeightAfter) {
      util.nextTick(() => {
        fixHeightWithColumns($element);
      }, 100);
    }
  };

  const undo = () => update(oldStyles);
  const redo = () => update(styles);

  redo();
  if (history) History.push(undo, redo, 'Update menu object style');
};

const refreshStyles = ($comp) => {
  const styles = buildCssRules($comp.attr('id'), getStyles($comp), getNumPrices(getMenuItems($comp)));
  updateStyleSheet($comp, styles);
  util.nextTick(() => {
    setHeights($comp);
  });
};

function ensureIds($comp) {
  if (!$comp.attr("data-id")) {
    $comp.attr({
      "data-source": "mhm",
      "data-id": util.UUID.get()
    })
  }
}

const getSelectionState = (state, $element) => {
  const $items = $element.find('.items');
  const opacity = $items.css('opacity') * 100;
  const menuObjectItems = getMenuItems($element);
  const styles = getStyles($element);
  styles['mo-content'] = styles['mo-content'] || {};

  let toOverwrite = false;
  if (!styles[TAG]) {
    styles[TAG] = styles[DESCRIPTION];
    toOverwrite = true;
  }
  if (toOverwrite) {
    overwriteStyles($element, styles);
  }

  let backgroundColor = '';
  let backgroundColorOpacity = 100;
  let bgData = $element.attr('data-color') ? JSON.parse($element.attr('data-color')) : {mode: 'solid', colors: [styles['mo-content'].background, '#000']};
  backgroundColor = bgData.colors[0];
  const tc = tinycolor(bgData.colors[0]);
  backgroundColorOpacity = tc.getAlpha() * 100;

  let moNameBackgroundColor = '';
  let moNameBackgroundOpacity = 100;
  let moNameBgData =  $element.attr('data-mo-name-color') ? JSON.parse($element.attr('data-mo-name-color')) : {mode: 'no-fill', colors: ['#fff', '#000']};
  moNameBackgroundColor = moNameBgData.colors[0];
  const tc2 = tinycolor(moNameBgData.colors[0]);
  moNameBackgroundOpacity = tc2.getAlpha() * 100;

  let moNameBackgroundRadius = 0;
  if (styles['mo-name'] && styles['mo-name']['border-radius']) {
    moNameBackgroundRadius = parseFloat(styles['mo-name']['border-radius']) * 10;
  }

  let moNameLineWidth = 0;
  let moNameLineColor = util.getMONameBorderColor(null, 'border-bottom');
  if (styles['mo-name'] && styles['mo-name']['border-bottom']) {
    const split = styles['mo-name']['border-bottom'].split(' solid ');
    if (split.length > 1) {
      [moNameLineWidth, moNameLineColor] = split;
      moNameLineWidth = parseFloat(moNameLineWidth) * 10;
    }
  }

  let moNameBorderWidth = 0;
  let moNameBorderColor = util.getMONameBorderColor(null, 'border');
  if (styles['mo-name'] && styles['mo-name']['border']) {
    const split = styles['mo-name']['border'].split(' solid ');
    if (split.length > 1) {
      [moNameBorderWidth, moNameBorderColor] = split;
      moNameBorderWidth = parseFloat(moNameBorderWidth) * 10;
    }
  }

  let moNotesLineWidth = 0;
  let moNotesLineColor = util.getMONotesLineColor();
  if (styles['mo-notes'] && styles['mo-notes']['border-bottom']) {
    [moNotesLineWidth, moNotesLineColor] = styles['mo-notes']['border-bottom'].split(' solid ');
    moNotesLineWidth = parseFloat(moNotesLineWidth) * 10;
  }

  const borderRadius = parseFloat(styles['mo-content']['border-radius'] || 0) * 10;

  let borderWidth = 0;
  let borderColor = util.getMOBorderColor();
  const {border} = styles['mo-content'];
  if (border && border.indexOf('solid') > -1) {
    [borderWidth, borderColor] = border.split(' solid ');
    borderWidth = parseFloat(borderWidth) * 10;
  }

  let numColumns = 1;
  if ($element.attr('data-num-columns')) {
    numColumns = parseInt($element.attr('data-num-columns'));
  }
  let columnGap = 0;
  if ($element.attr('data-column-gap') !== undefined) {
    columnGap = parseInt($element.attr('data-column-gap'));
  }
  let columnWidths = [];
  if ($element.attr('data-column-widths') !== undefined) {
    columnWidths = JSON.parse($element.attr('data-column-widths'));
  }

  let view;
  if (state.view.startsWith('text-mo')) {
    view = state.view;
  } else {
    view = "text-mo";
  }

  let subview = 'add-new';
  if (state.isMobileVersion) {
    subview = 'items';
  } else if (!state.isMobileVersion && view === "mo-import") {
    subview = 'designs';
  }

  const isLocked = util.isLocked($element);
  const width = util.getWidth($element, state.designUnit);

  const isHyperlink = util.isHyperlink($element);
  const href = util.getHref($element);

  return {
    ...state,
    $element,
    $elements: [$element],
    hasSelection: true,
    selectionType: MENU_OBJECT,
    menuObjectItems,
    menuObjectStyles: styles,
    menuObjectLayout: $element.attr('data-layout') || 'stacked',
    iconLayout: $element.attr('icon-layout') || 'icon-right',
    iconsInDescription: $element.attr('data-icons-in-description') === 'true' || false,
    iconPosition: $element.attr('data-icon-position') ? $element.attr('data-icon-position') : 'name',
    showMenuTag: $element.attr('data-show-tag') === "true" || false,
    hidePrices: $element.attr('data-hide-prices') === "true" || false,
    hideTrailingZeroes: $element.attr('data-hide-trailing-zeroes') === "true" || false,
    inlineExtras: $element.attr('data-inline-extras') === "true" || false,
    showModifiers: $element.attr('data-show-modifiers') === "true" || false,
    modifierLayout: $element.attr('data-modifier-layout') ? $element.attr('data-modifier-layout') : 'in-line',
    modifierDivider: $element.attr('data-modifier-divider') ? $element.attr('data-modifier-divider') : '',
    menuTagLayout: $element.attr('data-tag-layout') || 'above',
    priceDivider: $element.attr('data-price-divider') || '',
    priceBorder: $element.attr('data-price-border') ? $element.attr('data-price-border') : 'none',
    view,
    subview,
    isLocked,
    isHyperlink,
    href,

    isInGroup: $element.parents('.group').length > 0,

    opacity,

    borderRadius,
    borderWidth,
    borderColor,
    backgroundColor,
    backgroundColorOpacity,
    moNameBackgroundRadius,
    moNameBackgroundColor,
    moNameBackgroundOpacity,
    moNameLineWidth,
    moNameLineColor,
    moNameBorderWidth,
    moNameBorderColor,
    moNotesLineWidth,
    moNotesLineColor,

    numColumns,
    columnGap,
    columnWidths,

    width
  };
};

function convertMenuObjectPriceStyles() {
  $('.pages .page .content div[data-component="menu-object"]').each(function() {
    const $element = $(this);
    const styles = getStyles($element);
    styles['mo-content'] = styles['mo-content'] || {};

    let toOverwrite = false;
    let stylesConverted = Object.keys(styles).some(key => key.includes('price-entry:nth-child'));
    if (!stylesConverted) {
      if (!styles[PRICEENTRY]) styles[PRICEENTRY] = {};
      ['font-size', 'font-family', 'text-transform', 'font-weight', 'font-style', 'text-decoration', 'color', 'line-height'].forEach((attr) => {
        if (styles[PRICE] && styles[PRICE][attr]) {
          styles[PRICEENTRY][attr] = styles[PRICE][attr];
          delete styles[PRICE][attr];
        }
      })
      toOverwrite = true;
    }
    if (toOverwrite) {
      overwriteStyles($element, styles);
    }
  })
}

function addMenuObjectDefaultModifierStyles() {
  $('.pages .page .content div[data-component="menu-object"]').each(function() {
    const $element = $(this);
    const styles = getStyles($element);

    let toOverwrite = false;
    [MODIFIERNAME, MODIFIERENTRYNAME, MODIFIERENTRYPRICE].forEach(key => {
      if (!styles[key]) {
        toOverwrite = true;
        styles[key] = {};
        ['font-size', 'font-family', 'color'].forEach(attr => {
          if (styles[EXTRAS][attr]) {
            styles[key][attr] = styles[EXTRAS][attr];
          }
        })
        styles[key]['line-height'] = '1.2em';
      }
    })
    if (toOverwrite) {
      overwriteStyles($element, styles);
    }
  })
}

function convertMenuItemHighlightIds() {
  $('.pages .page .content div[data-component="menu-object"]').each(function() {
    const $element = $(this);
    $element.find('.item.highlighted').each(function () {
      const $item = $(this);
      if (!$item.attr('data-highlight-id')) {
        $item.attr('data-highlight-id', $item.attr('data-id'));
      }
    });
  })
}

function rerenderForModifiers() {
  $('.pages .page .content div[data-component="menu-object"]').each(function() {
    const $element = $(this);
    if ($element.find('.modifiers').length && $element.find('.modifiers').hasClass('to-rerender')) {
      const items = getMenuItems($element);
      updateContent($element, items, false);
    }
  })
}

const updateStateItems = ($element) => {
  setActive($element);
  const items = getMenuItems($element);
  store.dispatch(actions.showMenuContentModal(items));
};

const getHtmlItems = (items, layout, $clone, moRendererConfig = null) => {
  if (moRendererConfig) {
    moRendererConfig.iconAlign = moRendererConfig.iconAlign ? moRendererConfig.iconAlign : 'icon-right';
  } else {
    moRendererConfig = {
      iconAlign: 'icon-right',
      iconPosition: 'name',
      showTags: false,
      menuTagLayout: 'above',
      hidePrices: false,
      inlineExtras: false,
      showModifiers: false,
      modifierLayout: 'in-line'
    }
  }
  let content = '<div class="items">';
  content += Renderer[layout] ? Renderer[layout](items, $clone, {
    iconAlign: moRendererConfig.iconAlign,
    iconPosition: moRendererConfig.iconPosition,
    showTags: moRendererConfig.showTags,
    menuTagLayout: moRendererConfig.menuTagLayout,
    hidePrices: moRendererConfig.hidePrices,
    inlineExtras: moRendererConfig.inlineExtras,
    showModifiers: moRendererConfig.showModifiers,
    modifierLayout: moRendererConfig.modifierLayout
  })
  : Renderer.default(items, moRendererConfig.iconAlign, $clone);
  content += '</div>';
  return content;
};

function removePreviousLineHeightSettings($item) {
  $item.css({'line-height': ''});
  const $spansAndDivs = $item.find('span, div');
  $spansAndDivs.each(function () {
    let $text = $(this);
    if ($text.is('div')) {
      const $textChildren = $text.children();
      if ($textChildren.length > 0) {
        $text = $($textChildren[0]);
        if ($text.is('br')) {
          $text.removeAttr('style');
          return true;
        }
      }
    }

    $text.css({'height': '', 'line-height': ''});
    if ($text.is('span')) {
      const $closestDiv = $text.closest('div');
      $closestDiv.css({'height': '', 'line-height': ''});
      $closestDiv.removeData('lh-fixed');
    }
  });

  return $spansAndDivs;
}

const fixLineHeights = ($mo, force) => {
  const layout = $mo.attr('data-layout');
  if (!force && $mo.data('checksum') === md5(JSON.stringify(getStyles($mo)) + '_' + layout)) {
    return;
  }

  const isInline = INLINE_LAYOUTS.includes(layout);
  const isBinLayout = layout.indexOf('bin') > -1;
  util.nextTick(() => {
      const styles = getStyles($mo);
      const $items = $mo.find('.item');
      let hasGridPrices = false;

      $items.each(function (idx) {
        const $item = $(this);
        if ($item.closest('.page').length === 0) {
          return true;
        }

        const $spansAndDivs = removePreviousLineHeightSettings($item);

        $spansAndDivs.each(function () {
          let $text = $(this);
          if ($text.css('display') === 'none' ||
              (!isBinLayout && $text.hasClass('bin-entry')) ||
              $text.closest('.modifiers').length > 0) {
            return true;
          }

          if ($text.is('div')) {
            let $textChildren = $text.children();
            if ($textChildren.length > 0) {
              $text = $($textChildren[0]);
              if ($text.is('br')) {
                $text.removeAttr('style');
                return true;
              }

              $textChildren = $text.children();
              if ($textChildren.length > 0) {
                let $nameWithIcons = $($textChildren[0]);
                const $nameWithIconsNext = $nameWithIcons.next();
                if ($nameWithIcons.hasClass('name') && $nameWithIconsNext.hasClass('icon') || $nameWithIcons.hasClass('icon') && $nameWithIconsNext.hasClass('name')) {
                  $text = $nameWithIcons;
                }
              }
            }
          }

          let textHeight = $text.height();
          if ($text.is('span') && $text.hasClass('price')) {
            const $parent = $text.parent();
            const $txtChildren = $text.children();
            const isEmpty = $txtChildren.length === 1 && $txtChildren.eq(0).html().trim() === '';
            if (isEmpty && priceLineLayouts.includes(layout)) {
              $text.css({'height': '0px', 'line-height': '0px', 'display': 'none'});
            }
            if ($parent.children().length === 1 && isEmpty) {
              textHeight = 0;
              $parent.css({'height': '0px', 'line-height': '0px'});
            }
          }
          if (textHeight > 0) {
            let computedStyles = window.getComputedStyle($text.get(0));
            let lineHeight = computedStyles.getPropertyValue('line-height').replace('px', '');

            let avgLineHeight = parseFloat(lineHeight);
            let height = textHeight;

            if ($text.is('span')) {
              let $parent = $text.closest('div');
              if ($parent.data('lh-fixed')) {
                return true;
              }

              height = $parent.height();

              /**[NAME_DESCRIPTION] for layouts that have the menu name and menu description inline.*/
              //these calculations should only be applied for the scenarios where the name, description, and/or price are inline.
              if (isInline) {
                const $children = $parent.children();
                let chars = 0;
                let total = 0;
                $children.each(function () {
                  const $span = $(this);
                  const lh = parseFloat($span.css('line-height').replace('px', ''));
                  let spanText = $span.text().trim();
                  if ($span.hasClass('price')) {
                    spanText = spanText.replace(/\s+/g, '');
                  }
                  chars += spanText.length;
                  total += (spanText.length * lh);

                  if ($span.hasClass('icon')) {
                    $span.find('.icon-entry').each(function () {
                      const $icon = $(this);
                      chars += 1;
                      total += $icon.height();
                    })
                  }
                })

                if (total > 0) {
                  avgLineHeight = total / chars;
                }
              }
            }

            let lines = height > 0 ? height / avgLineHeight : 0;
            if (lines) lines = Math.max(Math.round(lines), 1);

            if ($text.is('span')) {
              let $parent = $text.closest('div');
              if ((inlinePriceColumnLayouts.includes(layout) || layout.indexOf('bin') > -1) && ($parent.hasClass('left') || $parent.prev().hasClass('bin-entry'))) {
                return true;
              }

              if (priceColumns.includes(layout) && isBinLayout) {
                if (!$parent.hasClass('right')) {
                  let totalHeight = 3;
                  const element = $parent[0];
                  for (const child of element.children) {
                    totalHeight += child.offsetHeight;
                  }
                  height = totalHeight;
                  lineHeight = height / lines;
                }
              }

              if (!$parent.data('lh-fixed')) {
                if (isInline) {
                  $parent.css({
                    'height': height,
                    'line-height': ''
                  });
                } else {
                  $parent.css({
                    'height': lineHeight * lines + 'px',
                    'line-height': lineHeight + 'px'
                  });
                }
                $parent.data('lh-fixed', true);
              }
            } else {
              if (!(isBinLayout && priceColumns.includes(layout) && ($text.hasClass('bin') || $text.hasClass('bin-header') || $text.hasClass('bin-entry')))) {
                $text.css({
                  'height': lineHeight * lines + 'px',
                  'line-height': lineHeight + 'px'
                });
              }
            }
          }
        });

        hasGridPrices = $item.children().first().hasClass('grid-prices');
        const hidePrices = $mo.attr('data-hide-prices') === "true" || false;
        const inlineExtras = $mo.attr('data-inline-extras') === "true" || false;
        fixLineHeightsGridPrices($items, $item, hidePrices, inlineExtras, hasGridPrices);
      });

      if (isBinLayout && layout.indexOf('header') > -1) {
        fixLineHeightsBinHeader($items);
      }

      if (isBinLayout) {
        maybeExpandBinEntries($items, priceColumns.includes(layout));
        util.nextTick(() => {
          fixDots($mo);
        });
      }

      if (hasGridPrices) {
        maybeExpandGridPrices($items);
      }

      util.nextTick(() => fixScale($mo));

      const str = JSON.stringify(styles) + '_' + layout;
      if (str) {
        $mo.data('checksum', md5(str));
      }
    }
  )
};

function fixScale($mo) {
  const $items = $mo.find('.mo-content');
  let newHeight = $items[0].getBoundingClientRect().height / getPageZoom() / Interactable.of($mo).getScale();

  $mo.css({'height': `${newHeight}px`});
  $mo.find('.wrapper').css({'height': `${newHeight}px`});
}

function fixItemLineHeight($item) {
  getHeightBasedOnChildren($item, true);
}

function getHeightBasedOnChildren($itemKid, overwriteHeights) {
  let height = 0;
  if ($itemKid.children().length) {
    let childHeights = [];
    $itemKid.find('> *').each(function () {
      const $entry = $(this);
      const clientRect = $entry[0].getBoundingClientRect();
      const top = (clientRect.top + '');
      const bottom = (clientRect.bottom + '');
      childHeights.push({
        elem: $entry,
        height: getHeightBasedOnChildren($entry, overwriteHeights),
        top: parseInt(top.substring(0, top.indexOf('.'))),
        bottom: parseInt(bottom.substring(0, bottom.indexOf('.'))),
        sameLineElements: [],
      });
    });

    childHeights = childHeights.sort((a, b) => {
      let topDiff = a.top - b.top;
      let bottomDiff = a.bottom - b.bottom;
      const threshold = 5;

      if (topDiff === 0 || Math.abs(topDiff) <= threshold || bottomDiff === 0 || Math.abs(bottomDiff) <= threshold) {
        topDiff = b.height - a.height;
        if (topDiff > 0) {
          a.sameLineElements.push(b);
        } else {
          b.sameLineElements.push(a);
        }
      }

      return topDiff;
    });

    childHeights.forEach(entry => {
      if (!entry.sameLineElements.length) {
        height += entry.height;
      }
    });
  } else {
    height += $itemKid.outerHeight();
  }
  if (overwriteHeights) {
    $itemKid.css({'height': `${height}px`});
  }
  return height;
}

function maybeExpandGridPrices($items) {
  if ($items.length) {
    const largestSize = findLargestPriceWidth($items);
    $items.find('.price-entry').css({
      width: `${largestSize}px`
    });
  }
}

function maybeExpandBinEntries($items, isPriceColumnLayout) {
  if ($items.length) {
    const $bins = $items.find('.bin-entry');
    let hasFilledBin = false;
    $bins.each(function() {
      if ($(this).text().trim()) hasFilledBin = true;
    });
    if (!hasFilledBin) {
      $bins.css({
        display: 'none'
      })
      return;
    }

    const largestSize = findLargestBinWidth($items);
    $bins.css({
      width: `${largestSize}px`,
      'min-width': `${largestSize}px`
    });

    if (isPriceColumnLayout) {
      const $modifiers = $items.find('.modifiers');
      $modifiers.css({
        'margin-left': `calc(${largestSize}px + 0.5em)`
      })
    }
  }
}

function fixLineHeightsBinHeader($items) {
  let height = 0;

  const $firstItem = $items.first();
  const $right = $firstItem.find('.bin-entry').next();
  const $binHeader = $firstItem.find('.bin-entry .bin-header');

  if ($right.length && $binHeader.length) {
    height = $binHeader.height();
    $right.css({
      'margin-top': height
    });
  }
}

async function fixLineHeightsGridPrices($items, $item, hidePrices, inlineExtras, hasGridPrices) {
  const $priceEntries = $item.find('.right .price .price-entry');

  if (hasGridPrices) {
    $priceEntries.removeAttr('style');
    $priceEntries.css({
      'text-align': 'center',
      'display': hidePrices ? 'none' : 'flex',
      'flex-direction': 'column',
      'align-items': 'center'
    });

    $item.find('.right .price').css({
      'height': '100%'
    });

    $item.find('.description-block').css({
      'line-height': '1em'
    })
  }

  const $sizes = $item.find('.right .price .price-entry .sp-size');
  const $firstSize = $sizes.eq(0);
  const $left = $item.find('.left');
  const $right = $item.find('.right');
  const hasDescriptionSameLine = !$item.hasClass('top') && !$item.hasClass('bottom');

  let hasPriceHeader = false;
  $sizes.each(function() {
    if ($(this).text().trim()) hasPriceHeader = true;
  });
  const layout = $item.closest('.menu-object').attr('data-layout');
  const isFirstItem = $item.is($items.first());
  let height = 0;
  if (hasGridPrices) {
    if (isFirstItem) {
      if (layout === 'bin-price-column-header' || layout === 'bin-prices-right-header') {
        const $binHeader = $items.first().find('.bin-entry .bin-header');
        const hasBinHeader = $binHeader.text().trim();
        if (!hasPriceHeader && hasBinHeader) {
          $right.css({
            'margin-top': $binHeader.height()
          })
        } else if (hasPriceHeader && !hasBinHeader) {
          $left.css({
            'margin-top': $firstSize.height()
          });
          $right.css({
            'margin-top': 0
          });
        } else {
          $left.css({
            'margin-top': 0
          });
          $right.css({
            'margin-top': 0
          });
        }
      } else {
        $right.css({
          'margin-top': 0
        });
        height = $firstSize.height();
        if (height && hasPriceHeader) {
          $left.css({
            'margin-top': height
          });
        } else {
          $left.css({
            'margin-top': '0'
          });
        }
      }
    } else {
      $left.css({
        'margin-top': 0
      });
      $right.css({
        'margin-top': 0
      });
    }
  }

  if (isFirstItem) {
    const $element = $items.closest('.menu-object');
    if (hasGridPrices && topAlignPriceColumnLayouts.includes(layout) && hasPriceHeader) {
      patchStyles($element, {
        type: FIRSTITEMPRICEDIVIDER,
        key: 'margin-top',
        value: `${$firstSize.height()}px`
      })
    } else {
      patchStyles($element, {
        type: FIRSTITEMPRICEDIVIDER,
        key: 'margin-top',
        value: ''
      })
    }
  }

  if (hasGridPrices) {
    let $descriptionBlock = $left.find('.description-block');
    if ($descriptionBlock.hasClass('description-block')) {
      $descriptionBlock.css({'height': ''});
    } else {
      $descriptionBlock.removeAttr('style');
    }
    if ($right.length) {
      const nameHeight = $left.find('.name').height() || 0;
      const tagHeight = $left.find('.tag:visible').height() || 0;
      const descriptionHeight = 0;
      // const descriptionHeight = $left.find('.description').text().trim() ? $left.find('.description').height() || 0 : 0;
      const extrasHeight = $left.find('.extras').text().trim() ? $left.find('.extras').height() || 0 : 0;
      const totalHeight = (hasDescriptionSameLine ? 0 : nameHeight) + descriptionHeight + (inlineExtras ? 0 : tagHeight + extrasHeight);

      $left.css({
        'min-height': totalHeight,
        'height': ''
      });
      $right.css({
        'min-height': totalHeight,
        'height': ''
      });
    }
  }
}

function findLargestPriceWidth($items) {
  let maxWidth = 0;
  $items.each(function() {
    const $item = $(this);
    const $entries = $item.find('.price-entry:not(.empty)');
    $entries.each(function() {
      const $entry = $(this);
      if ($entry.width() > maxWidth) {
        maxWidth = $entry.width();
      }
    });
  });
  return maxWidth;
}

function findLargestBinWidth($items) {
  let maxWidth = 0;
  $items.each(function(idx) {
    const $item = $(this);
    const $entries = idx === 0 ? $item.find('.bin-entry:not(.empty)>div') : $item.find('.bin-entry:not(.empty)>.bin');
    $entries.each(function() {
      const $entry = $(this);
      if ($entry.width() > maxWidth) {
        maxWidth = $entry.width();
      }
    })
  });
  return maxWidth;
}

function getItemProperty(type, $items, idx) {
  const $entries = $items.eq(idx).find('.right .price .price-entry .sp-' + type);

  let count = 0;
  $entries.each(function() {
    const $entry = $(this);
    if ($entry.html().trim() !== '') {
      count++;
    }
  });
  return count;
}

const resetLineHeightsStandalone = (ticked = true) => {
  function work() {
    $('.menu-object').each((index, element) => {
      let $mo = $(element);
      $mo.find('.item').each(function () {
        const $item = $(this);

        $item.find('.position').each(function () {
          $(this).remove();
        });

        $item.css({'line-height': ''});

        $item.find('span, div').each(function () {
          let $text = $(this);
          if ($text.is('div') && $text.children().length > 0) {
            $text = $($text.children()[0]);
          }

          $text.css({'height': '', 'line-height': ''});
          if ($text.is('span')) {
            $text.closest('div').css({'height': '', 'line-height': ''});
          }
        })
      })
    })
  }

  if (ticked) {
    util.nextTick(work);
  } else {
    work();
  }
};

const fixLineHeightsStandalone = () => {
  util.nextTick(
    () => {

      $('.menu-object').each((index, element) => {
        let $mo = $(element);
        fixLineHeights($mo);
      })
    }
  )
};

window.fixLineHeights = fixLineHeightsStandalone;
window.resetLineHeights = resetLineHeightsStandalone;

const getHtmlContent = (items, config) => {
  let moItems = [];
  let moName = '';
  let moNotes = '';
  items.forEach((it) => {
    if (it.name) {
      moItems.push(it);
    } else if (it.moName) {
      moName = it.moName;
    } else if (it.moNotes) {
      moNotes = it.moNotes;
    }
  });
  return `<div 
            id="${config.id}" 
            data-component="menu-object" 
            class="menu-object" 
            data-layout="${config.layout}" 
            data-show-tag="${config['show-menu-tag']}" 
            data-tag-layout="${config['tag-layout']}" 
            data-mo-name-color="${config['mo-name-color']}"
            data-hide-prices="${config['hide-prices']}"
            data-hide-trailing-zeroes="${config['hide-trailing-zeroes']}"
            data-price-border="${config['price-border']}"
            data-icon-position="${config['icon-position']}"
            data-show-modifiers="${config['show-modifiers']}"
            data-modifier-layout="${config['modifier-layout']}"
          >
    <div class="wrapper">
      <div class="config" translate="no">${JSON.stringify({styles: config.styles})}</div>
      <style>${buildCssRules(config.id, config.styles, getNumPrices(items))}</style>
      <div class="mo-content">
        ${moName ? `<div class="mo-name">${moName}</div>` : ''}
        ${moNotes ? `<div class="mo-notes">${moNotes}</div>` : ''}
        ${getHtmlItems(moItems, config.layout, null, { iconAlign: "icon-right", iconsInDescription: false, iconPosition: config['icon-position'], showTags: config["show-menu-tag"], menuTagLayout: config["tag-layout"], hidePrices: config["hide-prices"], showModifiers: config["show-modifiers"], modifierLayout: config["modifier-layout"] })}
      </div>
    </div>
  </div>`;
}

function fixGroupHeight($element, $group, cfg) {
  $element.css('height', 'auto');
  CanvasRenderer.ensureGroupDimensions($element);
  CanvasRenderer.regroup($group, {reselect: false});

  let reselect = !cfg || cfg.reselect !== false;
  if (store.getState().view === 'print') {
    reselect = false;
  }
  if (reselect) {
    $element.click();
  }
}

function onPostRender($element, layout, keepCurrentHeights) {
  ensureCorrectLayoutStyles($element);

  const callback = PostRenderer[layout];
  if (callback) callback($element);
  if (!keepCurrentHeights) {
    util.nextTick(() =>  setHeights($element));
  }
}

function getDifferencesFromMenuObjects(first, second) {
  let nrDifferences = 0;
  first.forEach(element => {
    const found = second.find((el) => JSON.stringify(element) === JSON.stringify(el));
    if(!found) nrDifferences++;
  });

  if(nrDifferences > 1 || nrDifferences === 1 && first.length === 1) return false;
  return true
}

const updateMOName = ($element, moName, history = true, shouldRedo = true) => {
  let $name = $element.find('.mo-name');

  if (!$name.length) {
    const nameHTML = '<div class="mo-name"></div>';
    $element.find('.mo-content').prepend(nameHTML);
    patchStyles($element, {
      type: 'mo-name',
      key: 'padding',
      value: getDefaultMONamePadding()
    })
    fixLineHeights($element);
    $name = $element.find('.mo-name');
  }

  const oldNameInnerHTML = $name.html();
  let oldNameHTML = '';
  if (oldNameInnerHTML) {
    oldNameHTML = `<div class="mo-name selected">${oldNameInnerHTML}</div>`;
  }
  const newNameHTML = moName ? `<div class="mo-name selected">${moName}</div>`.replaceAll('\n', '<br>') : '';

  function update(nameHTML) {
    $element?.find('.mo-name').remove();
    $element.find('.mo-content').prepend(nameHTML);
  }

  function undo() {
    update(oldNameHTML);
  }

  function redo() {
    update(newNameHTML);
  }
  if(shouldRedo) redo();
  if (history) {
    History.push(undo, redo, 'Update menu object name');
  }
}

const updateMONotes = ($element, moNotes, history = true, shouldRedo = true) => {
  let $notes = $element.find('.mo-notes');

  if (!$notes.length) {
    const notesHTML = '<div class="mo-notes"></div>';
    if ($element.find('.mo-content .mo-name').length) {
      $element.find('.mo-content .mo-name').after(notesHTML);
    } else {
      $element.find('.mo-content').prepend(notesHTML);
    }
    patchStyles($element, {
      type: 'mo-notes',
      key: 'padding',
      value: getDefaultMONotesPadding()
    })
    fixLineHeights($element);
    $notes = $element.find('.mo-notes');
  }

  const oldNotesInnerHTML = $notes.html();
  let oldNotesHTML = '';
  if (oldNotesInnerHTML) {
    oldNotesHTML = `<div class="mo-notes selected">${oldNotesInnerHTML}</div>`;
  }
  const newNotesHTML = moNotes ? `<div class="mo-notes selected">${moNotes}</div>`.replaceAll('\n', '<br>') : '';

  function update(notesHTML) {
    $element?.find('.mo-notes').remove();
    if ($element?.find('.mo-name').length) {
      $element?.find('.mo-content .mo-name').after(notesHTML);
    } else {
      $element?.find('.mo-content').prepend(notesHTML);
    }
  }

  function undo() {
    update(oldNotesHTML);
  }

  function redo() {
    update(newNotesHTML);
  }
  if(shouldRedo) redo();
  if (history) {
    History.push(undo, redo, 'Update menu object notes');
  }
}

const deleteMOName = ($element, history = true, shouldRedo = true) => {
  const $name = $element.find('.mo-name');
  const oldNameInnerHTML = $name.html();
  let oldNameHTML = '';
  if (oldNameInnerHTML) {
    oldNameHTML = `<div class="mo-name">${oldNameInnerHTML}</div>`;
  }

  function update(nameHTML = null) {
    if (!nameHTML) {
      $element.find('.wrapper .mo-name').remove();
    } else {
      $element.find('.mo-content').prepend(nameHTML);
    }
    fixLineHeights($element, true);
  }

  function undo() {
    update(oldNameHTML);
  }

  function redo() {
    update()
  }

  if (shouldRedo) redo();
  if (history) {
    History.push(undo, redo, 'Delete menu object name');
  }
}

const deleteMONotes = ($element, history = true, shouldRedo = true) => {
  const $notes = $element.find('.mo-notes');
  const oldNotesInnerHTML = $notes.html();
  let oldNotesHTML = '';
  if (oldNotesInnerHTML) {
    oldNotesHTML = `<div class="mo-notes">${oldNotesInnerHTML}</div>`;
  }

  function update(notesHTML = null) {
    if (!notesHTML) {
      $element.find('.wrapper .mo-notes').remove();
    } else {
      if ($element?.find('.mo-name').length) {
        $element?.find('.mo-content .mo-name').after(notesHTML);
      } else {
        $element?.find('.mo-content').prepend(notesHTML);
      }
    }
    fixLineHeights($element, true);
  }

  function undo() {
    update(oldNotesHTML);
  }

  function redo() {
    update()
  }

  if (shouldRedo) redo();
  if (history) {
    History.push(undo, redo, 'Delete menu object notes');
  }
}

function fullyReplaceContent(sections) {
  const config = JSON.parse(getFirstMenuItemConfig() || DEFAULT_MO_STYLE);

  $(".menu-object").remove();

  sections.forEach((section, idx) => {
    const mo = new designDomain.MenuObject({
      config: JSON.stringify({
        id: `${new Date().getTime()}`,
          ...config
      }),
      content: JSON.stringify(section.items)
    });
    const html = getHtmlContent(mo.content, mo.config);

    const $page = util.getPageInViewport($('.page'));

    addComponent($page.attr('id'), html, {
      position: {
        left: idx % 2 === 0 ? 20 : "center",
        top: 100 * idx
      },
      isFromTemplate: true,
      keepColors: true
    });
  });
}

const updateContent = ($element, items, history = true, keepCurrentHeights = false, updateMenuItems = true, shouldRedo = true, oldItems = undefined, groupName = "", isMGReplace = false, keepGroupNotes = false, group = undefined) => {
  const $clone = $element?.clone();
  const $parent = $element?.parent();
  const layout = $element?.attr('data-layout') || 'compact';
  const iconLayout = $element?.attr('icon-layout') || 'icon-right';
  const iconsInDescription = $element?.attr('data-icons-in-description') === 'true' || false;
  const iconPosition = $element?.attr('data-icon-position') ? $element?.attr('data-icon-position') : 'name';
  const showMenuTag = $element?.attr('data-show-tag') === "true" || false;
  const menuTagLayout = $element?.attr('data-tag-layout') || 'above';
  const hidePrices = $element?.attr('data-hide-prices') === "true" || false;
  const priceBorder = $element?.attr('data-price-border') ? $element?.attr('data-price-border') : 'none';
  const inlineExtras = $element?.attr('data-inline-extras') === "true" || false;
  const showModifiers = $element?.attr('data-show-modifiers') === "true" || false;
  const modifierLayout = $element?.attr('data-modifier-layout') || 'in-line';
  oldItems = oldItems || getMenuItems($element);
  const isEmpty = items.length === 0;

  const oldName = $element?.find('.mo-name').length ? $element?.find('.wrapper .mo-name').text() : null;
  const oldNotes = $element?.find('.mo-notes').length ? $element?.find('.wrapper .mo-notes').text() : null;

  function update(list, name = "", isMGReplace = false, notes = "") {
    if(updateMenuItems) store.dispatch(actions.setMenuObjectItems([...list]));
    $element?.find('.items').remove();

    if (!$element?.find('.wrapper').length) {
      $element?.append('<div class="wrapper"></div>');
    }

    $element?.find('.wrapper .mo-content').append(getHtmlItems(list, layout, $clone, { iconAlign: iconLayout, iconsInDescription, iconPosition, showTags: showMenuTag, menuTagLayout, hidePrices, inlineExtras, showModifiers, modifierLayout }));

    if (name === null) {
      deleteMOName($element, false);
    } else if (name) {
      updateMOName($element, name, false);
    }

    if (isMGReplace && !keepGroupNotes) {
      updateMONotes($element, "", false);
    } else if (notes) {
      updateMONotes($element, notes, false);
    }

    if(!keepCurrentHeights) util.nextTick(() => onPostRender($element, layout, keepCurrentHeights));
    fixLineHeights($element);
    if (layout.indexOf('bin') < 0) fixDots($element);
    updatePageBars($element);
    util.nextTick(() => {
      const int = Interactable.of($element);
      if (int.isSelected() && int.isSortable()) {
        int.refreshSortable();
      }
      int.afterRestore();
    });

    util.nextTick(() => {
      fixHeightWithColumns($element);
    }, 100);

    const columnWidths = $element.attr('data-column-widths') ? JSON.parse($element.attr('data-column-widths')) : [];
    setColumnWidths($element, columnWidths);
  }

  function undo() {
    if (isEmpty) {
      $parent.append($element);
    } else {
      if(!getDifferencesFromMenuObjects(oldItems, store.getState().menuObjectItems)) {
        store.dispatch(actions.goToView('text-mo'));
        store.dispatch(actions.goToSubview('add-new'));
        CanvasRenderer.deselectAll();
        store.dispatch(actions.deselect());
      }
      update(oldItems, oldName, false, oldNotes);
    }
  }

  function redo() {
    if (isEmpty) {
      removePageBars($element);
      $element.remove();
    } else {
      update(items, groupName, isMGReplace, group?.description);
    }
  }

  if(shouldRedo) redo();
  if (history) {
    History.push(undo, redo, 'Update menu object content');
  }
};

const ensureHasWrapper = ($element) => {
  if (!$element?.find('.wrapper').length) {
    $element?.append('<div class="wrapper"></div>');

    const $items = $element?.find('.items');
    const $cl = $items.clone();
    $cl.appendTo($element?.find('.wrapper'));
    $items.remove();
  }

  // $element.find('.item').each(function() {
  //   const $item = $(this);
  //   const $childs = $item.find('> *');
  //   $childs.each(function() {
  //     const $child = $(this);
  //     const idx = $child.index();
  //     const isFirst = !idx;
  //     const isLast = idx === $childs.length - 1;
  //
  //     let style = $child.attr('style') || '';
  //     console.log(style);
  //     const expectedStyle = 'padding';
  //     if (isFirst) {
  //       if (style.indexOf(expectedStyle) < 0) {
  //         style += 'padding: 1em 1em 0px 1em;';
  //         $child.attr('style', style);
  //       }
  //     } else if (isLast) {
  //       if (style.indexOf(expectedStyle) < 0) {
  //         style += 'padding: 0 0 1em 0;';
  //         $child.attr('style', style);
  //       }
  //     } else {
  //       if (style.indexOf(expectedStyle) < 0) {
  //         style += 'padding: 0 1em 0 1em;';
  //         $child.attr('style', style);
  //       }
  //     }
  //   });
  // });
  // util.nextTick(() => {
  //   fixLineHeights($element, true);
  // });
}

function fixDotsForPriceColumnsList($item, dots, hidePrices, $moElement) {
  const isPriceColumnDotLayout = $moElement.attr('data-layout') === 'prices-right-with-dot-leaders';
  let $element = $item?.find(".name");
  if (isPriceColumnDotLayout) {
    const inlineExtras = $moElement.attr('data-inline-extras') ? $moElement.attr('data-inline-extras') === "true" : false;
    if (!inlineExtras && $item?.find('.extras').text()) {
      $element = $item?.find('.extras').parent();
    } else {
      $element = $item?.find('.left');
    }
    $element.attr('style', '');
  }
  const $prices =  $item?.find(".price");
  const $priceEntry = $prices?.find('.price-entry:first');

  if(parseFloat($prices.css("font-size")) === 0) return;

  $item?.find(".dots")?.remove();

  if (!$item.text().trim()) return;

  if (dots && !hidePrices) {
    $element.css("white-space", "nowrap");
    if (isPriceColumnDotLayout) {
      $prices.find('.sp-size').each(function() {
        $(this).css('display', 'none');
      })
    }
    const height = $element[0].clientHeight;
    $element.css("white-space", "");

    const isMultiLineName = height !== $element[0].clientHeight;
    const pricesHeight = Math.max($prices[0].clientHeight, $priceEntry.height());

    let custom = height;
    const $dots = $("<span class='dots' />")

    $dots.css({
      color: $priceEntry.css("color"),
      fontWeight: $priceEntry.css("fontWeight"),
      fontSize: $priceEntry.css("fontSize"),
      fontFamily: $priceEntry.css("fontFamily"),
    });
    $element.append($dots);

    let limit;
    if (isMultiLineName) {
      limit = $element[0].clientHeight + (height / 2);
    } else {
      limit = pricesHeight > height ? height : pricesHeight;
      limit *= 1.45;
    }

    while (custom < limit) {
      $dots.append(". ");
      custom = $element[0].clientHeight;
    }

    $dots.css({
      color: $priceEntry.css("color"),
      fontWeight: $priceEntry.css("fontWeight"),
      fontSize: $priceEntry.css("fontSize"),
      fontFamily: $priceEntry.css("fontFamily"),
    });

    let errorMargin = DOT_ERROR_MARGIN_NAME_MULTI_PRICE;
    if (util.isSafari()) {
      errorMargin += 1;
    }
    if (isPriceColumnDotLayout) {
      $prices.find('.sp-size').each(function() {
        $(this).css('display', '');
      })
    }

    const html = $dots.html();
    $dots.html(html.substring(0, html.length - errorMargin > 0 ? html.length - errorMargin : 0));
  }
}

function fixDots($element) {
  let layout = $element.attr('data-layout');
  let dots = $element.attr('data-dots') === "true";
  const hidePrices = $element.attr('data-hide-prices') === "true" || false;

  if (util.isGroup($element)) {
    const $mo = $element.find('.menu-object');
    if ($mo.length > 0) {
      const $first = $mo.eq(0);
      layout = $first.attr('data-layout');
      dots = $first.attr('data-dots') === "true";
    }
  }

  if (layout.indexOf("-with-dot-leaders") > -1) {
    $element.find('.item').each(function () {
      fixDotsForPriceColumnsList($(this), dots, hidePrices, $element);
    });
  }
}

function updateDots($element, value) {
  const $elements = Array.isArray($element) ? $element : [$element];

  function update(value) {
    $elements.forEach(($element, idx) => {
      $element.attr('data-dots', value);
    });
  }

  const undo = () => update(!value);
  const redo = () => update(value);

  redo();
  History.push(undo, redo, 'Update menu object layout');
}

const updateLayout = ($element, layout, adjustNameNote = true) => {
  const $elements = Array.isArray($element) ? $element : [$element];
  const oldLayout = $elements.map($element => $element.attr('data-layout'));

  function update(layout) {
    $elements.forEach(($element, idx) => {
      const aux = Array.isArray(layout) ? layout[idx] : layout;
      $element.attr('data-layout', aux);
      const items = getMenuItems($element);
      if (priceColumns.includes(layout) && $element.attr('data-icon-position') === 'price') {
        updateIconPosition($element, 'name', false);
      }
      updateDots($element, true);
      updateContent($element, items, false);
      if (layout.indexOf('bin') > -1) {
        applyNameStylesToBin($element);
      }
      if (adjustNameNote) {
        util.nextTick(() => {
          const newAlign = $element.find('.name').css('text-align');
          patchStyles($element, {
            type: 'mo-name',
            key: 'text-align',
            value: newAlign
          })
          patchStyles($element, {
            type: 'mo-notes',
            key: 'text-align',
            value: newAlign
          })
        })
      }
      if ($element.attr('data-price-divider')) {
        patchStyles($element, {
          type: 'price-entry:not(.last)::after',
          key: 'bottom',
          value: bottomAlignPriceColumnLayouts.includes(layout) ? 0 : ''
        })
        patchStyles($element, {
          type: 'price-entry:not(.last)::after',
          key: 'top',
          value: bottomAlignPriceColumnLayouts.includes(layout) ? '' : 0
        })
      }
      if (!$element.attr('data-num-columns') || parseInt($element.attr('data-num-columns')) === 1) {
        fixPriceBorder($element);
      }
    });
    store.dispatch(actions.setMenuObjectLayout(layout));
  }

  const undo = () => update(oldLayout);
  const redo = () => update(layout);

  redo();
  History.push(undo, redo, 'Update menu object layout');
};

function updateIconLayout($element, iconLayout) {
  $element.attr('icon-layout', iconLayout);
  const items = getMenuItems($element);
  updateContent($element, items);
}

function updateIconsInDescription($element, iconsInDescription) {
  $element.attr('data-icons-in-description', iconsInDescription);
  const items = getMenuItems($element);
  updateContent($element, items);
}

function updateIconPosition($element, position, updateContentAfter = true) {
  $element.attr('data-icon-position', position);
  const items = getMenuItems($element);
  store.dispatch(actions.setIconPosition(position))
  if (updateContentAfter) {
    updateContent($element, items);
  }
}

function updateShowMenuTag($element, showMenuTag) {
  $element.attr('data-show-tag', showMenuTag);
  const items = getMenuItems($element);
  updateContent($element, items);
}

function updateShowModifiers($element, showModifiers) {
  $element.attr('data-show-modifiers', showModifiers);
  const items = getMenuItems($element);
  updateContent($element, items);
}

function updateModifierLayout($element, modifierLayout) {
  $element.attr('data-modifier-layout', modifierLayout);
  if (modifierLayout === 'stacked' && $element.attr('data-modifier-divider')) {
    updateModifierDivider($element, '');
    store.dispatch(actions.setModifierDivider(''));
  }
  const items = getMenuItems($element);
  updateContent($element, items);
}

function updateHidePrices($element, hidePrices) {
  $element.attr('data-hide-prices', hidePrices);
  const items = getMenuItems($element);
  updateContent($element, items);
  fixLineHeights($element, true);
}

function updateHideTrailingZeroes($element, hideTrailingZeroes) {
  $element.attr('data-hide-trailing-zeroes', hideTrailingZeroes);
  const items = getMenuItems($element);
  updateContent($element, items);
  fixLineHeights($element, true);
}

function updateInlineExtras($element, inlineExtras) {
  $element.attr('data-inline-extras', inlineExtras);
  const items = getMenuItems($element);
  updateContent($element, items);
  fixLineHeights($element, true);
}

function updateMenuTagLayout($element, menuTagLayout) {
  $element.attr('data-tag-layout', menuTagLayout);
  const items = getMenuItems($element);
  updateContent($element, items);
}

function getHeightRule($line, {nameLineHeight, generalLineHeight}) {
  const height = $line.height();
  const lineHeight = parseFloat($line.css('line-height'));
  const cstLineHeight = isName($line) ? nameLineHeight : generalLineHeight;

  // Here follows an awful patch:
  const roundOne = height / lineHeight;
  const roundTwo = height / lineHeight - .15;

  const rowCount = Math.round(roundTwo);
  return rowCount * cstLineHeight;
}

function getNameHeight($name) {
  let height = $name.height();
  const display = $name.css('display');
  if (display !== 'inline-block') {
    $name.css('display', 'inline-block');
    height = $name.height();
    $name.css('display', display);
  }
  return height;
}

function getGroupedHeightRule($line, {nameLineHeight, generalLineHeight}) {
  const $name = $line.children('.name');
  const nHeight = getNameHeight($name);
  const nFontSize = Math.round(parseFloat($name.css('font-size')));
  const nLineHeight = Math.round(parseFloat($name.css('line-height')));
  const nRowCount = Math.round(nHeight / nLineHeight);

  const height = $line.height() - nHeight;
  const fontSize = Math.round(parseFloat($name.parent().css('font-size')));
  const lineHeight = Math.round(parseFloat($line.css('line-height')));
  const rowCount = Math.round(height / lineHeight);

  const fontSizeQuantifier = Math.round(nFontSize / fontSize * 10) / 10;

  return (nRowCount * nameLineHeight * fontSizeQuantifier) + rowCount * generalLineHeight;
}

function setHeights($mo, cfg = {}) {
  if (util.isInGroup($mo)) {
    fixGroupHeight($mo, $mo.parents('.group'), cfg);
  }
  if (constants.APPLY_LINE_HEIGHT_PATCH) {
    fixLineHeights($mo);
  } else {
    resetLineHeightsStandalone();
  }
}

const isName = ($line) => $line.hasClass('name') || $line.find('name').length > 0

const ensureCorrectLayoutStyles = ($element) => {
  const layout = $element.attr('data-layout') || 'compact';
  let styles = getStyles($element);

  if (!styles) {
    return;
  }

  if (!styles['icon-entry'] || !styles['icon-entry']['color'] || !styles['icon-entry']['fill'] || !styles['icon-entry']['display']
    || !styles['icon-entry']['vertical-align'] || !styles['icon-entry']['height'] || !styles['icon-entry']['width']) {
    if (!styles['icon-entry']) {
      styles['icon-entry'] = {};
    }
    if (!styles['icon-entry']['color']) {
      styles['icon-entry']['color'] = styles['name']['color'] || constants.DEFAULT_TEXT_COLOR;
    }
    if (!styles['icon-entry']['fill']) {
      styles['icon-entry']['fill'] = styles['icon-entry']['color'] || styles['name']['color'] || constants.DEFAULT_TEXT_COLOR;
    }
    if (!styles['icon-entry']['display']) {
      styles['icon-entry']['display'] = 'inline-block';
    }
    if (!styles['icon-entry']['vertical-align']) {
      styles['icon-entry']['vertical-align'] = 'text-top';
    }
    if (!styles['icon-entry']['height']) {
      styles['icon-entry']['height'] = '1em';
    }
    if (!styles['icon-entry']['width']) {
      styles['icon-entry']['width'] = '1em';
    }

    $element.find('.config').text(JSON.stringify({styles}));
    updateStyleSheet($element, buildCssRules($element.attr('id'), styles, getNumPrices(getMenuItems($element))));
  }

  if (layout === 'price-list') {
    styles.name.margin = '0';
    styles.price.margin = '0';
    styles.description.margin = '0';

    $element.find('.config').text(JSON.stringify({styles}));
    updateStyleSheet($element, buildCssRules($element.attr('id'), styles, getNumPrices(getMenuItems($element))));
  }
};

const fixLayouts = ($element) => {
  const layout = $element.attr('data-layout') || 'compact';
  if (layout === 'price-list') {
    const items = getMenuItems($element);
    $element.find('.items').remove();
    if (!$element.find('.wrapper').length) {
      $element.append('<div class="wrapper"></div>');
    }
    $element.find('.wrapper .mo-content').append(getHtmlItems(items, layout));

    ensureCorrectLayoutStyles($element);
  } else {
    refreshStyles($element);
  }
};

function getActiveLayouts() {
  const $mos = $('.menu-object');
  const layouts = [];

  $mos.each(function() {
    const $mo = $(this);
    const layout = $mo.attr('data-layout');
    if (!layouts.includes(layout)) {
      layouts.push(layout);
    }
  });

  return layouts;
}

function getRatio($target) {
  let ratio = $target.attr('data-custom-ratio') && !Number.isNaN($target.attr('data-custom-ratio')) ? parseFloat($target.attr('data-custom-ratio')) : -1;
  if (ratio === -1) {
    ratio = !Number.isNaN($target.attr('data-ratio')) ? parseFloat($target.attr('data-ratio')) : -1;
  }
  return ratio;
}

function adaptEventToZoom(event, rotation, zoom) {
  event.delta.x = event.delta.x / zoom;
  event.delta.y = event.delta.y / zoom;

  let magX = event.delta.x;
  let magY = event.delta.y;
  if (event.edges.right) {
    event.deltaRect.right = Math.cos(rotation) * magX + Math.sin(rotation) * magY;
    event.deltaRect.width = event.deltaRect.right;
  } else if (event.edges.left) {
    event.deltaRect.left = -(Math.cos(rotation) * magX + Math.sin(rotation) * magY);
    event.deltaRect.width = event.deltaRect.left;
  }
  if (event.edges.top) {
    event.deltaRect.top = Math.sin(rotation) * magX - Math.cos(rotation) * magY;
    event.deltaRect.height = event.deltaRect.top;
  } else if (event.edges.bottom) {
    event.deltaRect.bottom = -Math.sin(rotation) * magX + Math.cos(rotation) * magY;
    event.deltaRect.height = event.deltaRect.bottom;
  }
}

function ensureKidsHeight($target, scale, $kid) {
  // $kid = $kid || $target.find('.wrapper, .ql-container');
  // scale = scale || Interactable.of($target).getScale() || 1;
  //
  // const w = parseFloat($target.attr('data-original-rect-width'));
  // const h = parseFloat($target.attr('data-original-rect-height'));
  // const r = w / h;
  // const maxWidth = $target.width() * (1 / scale);
  //
  // //const padding = parseFloat($target.find('.items').css('padding').replace('px', ''));
  //
  // $kid.css({
  //   width: `${maxWidth}px`,
  //   height: `${(maxWidth / r)}px`
  // });
}

const defaultTagStyles = {
  "font-size":"120%",
  "font-family":"Pathway Gothic One",
  "margin":"0 auto",
  "line-height":"1.2em",
  "color":"#777777"
}

const DEFAULT_MO_STYLE = JSON.stringify({
  "styles":{
     "item":{
        "margin-bottom":"1em",
        "line-height":"1.2em"
     },
     "name":{
        "font-size":"130%",
        "font-family":"Pathway Gothic One",
        "font-weight": "bold",
        "margin":"0 auto",
        "line-height":"1.2em",
        "color":"#000000"
     },
     "tag":{
      "font-size":"120%",
      "font-family":"Pathway Gothic One",
      "margin":"0 auto",
      "line-height":"1.2em",
      "color":"#777777"
    },
     "description":{
        "font-size":"120%",
        "font-family":"Pathway Gothic One",
        "margin":"0 auto",
        "line-height":"1.2em",
        "color":"#777777"
     },
     "price":{
        "margin":"0 auto",
     },
     "extras":{
        "font-size":"120%",
        "font-family":"Pathway Gothic One",
        "margin":"0 auto",
        "color":"#000000"
     },
     "modifier-name":{
        "font-size":"120%",
        "line-height":"1.2em",
        "font-family":"Pathway Gothic One",
        "color":"#000000"
     },
     "modifier-entry-name":{
        "font-size":"120%",
        "line-height":"1.2em",
        "font-family":"Pathway Gothic One",
        "color":"#000000"
     },
     "modifier-entry-price":{
        "font-size":"120%",
        "line-height":"1.2em",
        "font-family":"Pathway Gothic One",
        "color":"#000000"
     },
     "bin":{
      "font-size":"130%",
      "font-family":"Pathway Gothic One",
      "font-weight": "bold",
      "color":"#000000"
     },
     "bin-header":{
      "font-size":"130%",
      "font-family":"Pathway Gothic One",
      "font-weight": "bold",
      "color":"#000000"
     },
     "price-entry":{
        "font-size":"110%",
        "font-family":"Pathway Gothic One",
        "text-transform":"uppercase",
        "font-weight": "bold",
        "line-height":"1.2em",
        "color":"#000000"
     },
     "line-height":"1.2em"
  },
  "id":"mo-1",
  "layout":"price-name-left",
  "show-menu-tag":false,
  "tag-layout":"above",
  "mo-name-color":"",
  "hide-prices":false,
  "price-border":"none",
  "hide-trailing-zeroes":false,
  "icon-position":"name",
  "show-modifiers":false,
  "modifier-layout":'in-line'
});

function deselectNameNotes($element) {
  const $name = $element.find('.mo-name');
  const $notes = $element.find('.mo-notes');
  if ($name) $name.removeClass('selected');
  if ($notes) $notes.removeClass('selected');
}

function moPaginationPrev() {
  const currentIdx = store.getState().moSelectedItemIdx || 0;
  const $element = store.getState().$element;
  const totalItems = $element.find('.item').length;
  const curMOMode = store.getState().MOEditMode;
  const $items = $element.find('.item');

  if (currentIdx === 0 && curMOMode === 'items') {
    store.dispatch(actions.setMOEditMode('name-notes'));
    $items.eq(currentIdx).removeClass('selected');
  } else {
    let prevIdx = 0;

    if (curMOMode === 'name-notes') {
      prevIdx = totalItems - 1;
      store.dispatch(actions.setMOEditMode('items'));
      deselectNameNotes($element);
    } else {
      prevIdx = currentIdx - 1;
    }

    store.dispatch(actions.setMoSelectedItemIdx(prevIdx));
    $items.eq(currentIdx).removeClass('selected');
    $items.eq(prevIdx).addClass('selected');
  }
}

function moPaginationNext() {
  const currentIdx = store.getState().moSelectedItemIdx || 0;
  const $element = store.getState().$element;
  const totalItems = $element.find('.item').length;
  const curMOMode = store.getState().MOEditMode;
  const $items = $element.find('.item');

  if (currentIdx === totalItems - 1 && curMOMode === 'items') {
    store.dispatch(actions.setMOEditMode('name-notes'));
    $items.eq(currentIdx).removeClass('selected');
  } else {
    let nextIdx = 0;

    if (curMOMode === 'name-notes') {
      store.dispatch(actions.setMOEditMode('items'));
      deselectNameNotes($element);
    } else {
      nextIdx = currentIdx + 1;
    }

    store.dispatch(actions.setMoSelectedItemIdx(nextIdx));
    $items.eq(currentIdx).removeClass('selected');
    $items.eq(nextIdx).addClass('selected');
  }
}

function moPaginationDelete() {
  const $el = store.getState().$element;
  const idx = store.getState().moSelectedItemIdx;
  const $element = store.getState().$element;
  const curMOMode = store.getState().MOEditMode;

  if (curMOMode === 'name-notes') {
    $element.find('.wrapper .mo-name').remove();
    $element.find('.wrapper .mo-notes').remove();
    fixLineHeights($element, true);
    store.dispatch(actions.setMOEditMode('items'));
    return;
  }

  const ogNumItems = $el.find('.item').length;
  if (ogNumItems === 1) {
    $('.mo-option.delete').click();
  } else {
    markAsModified();
    let items = [...store.getState().menuObjectItems];
    items.splice(idx, 1);

    if (items.length === 0) {
      const active = new MenuItem();
      const items = [active];
      store.dispatch(actions.setMenuObjectItems(items));
      store.dispatch(actions.setIsMenuObjectCopied(false));
      store.dispatch(actions.setMoSelectedItemIdx(0));
    } else {
      store.dispatch(actions.setMenuObjectItems(items));
      updateContent($el, items);

      const newIdx = idx === 0 ? 0 : idx - 1;
      store.dispatch(actions.setMoSelectedItemIdx(newIdx));
      store.dispatch(actions.setMoLastSortDate(new Date().getTime()));
    }
  }

  const numColumns = $el.attr('data-num-columns') ? parseInt($el.attr('data-num-columns')) : 1;
  if (numColumns === 2 && ogNumItems === 2) {
    setColumns($el, 1);
  } else if (numColumns === 3 && ogNumItems === 3) {
    setColumns($el, 2);
  } else {
    util.nextTick(() => {
      fixHeightWithColumns($el);
    }, 100);
  }
}

function moAddItem($elem) {
  markAsModified();
  if (!store.getState().isMobileVersion) {
    store.dispatch(actions.setIsMOEditModal(true));
  }
  const $element = $elem || store.getState().$element;

  let existingItems = store.getState().menuObjectItems;
  if (!existingItems || !existingItems.length) {
    existingItems = getMenuItems($element);
  }

  deselectNameNotes($element);

  const active = new MenuItem();
  const items = [...existingItems, active];
  store.dispatch(actions.setMenuObjectItems(items));
  store.dispatch(actions.setIsMenuObjectCopied(false));
  store.dispatch(actions.setMoSelectedItemIdx(items.length - 1));
  store.dispatch(actions.setMOEditMode('items'));
  updateContent($element, items);

  canvas.onMenuItemClickSelected();

  util.nextTick(() => {
    fixHeightWithColumns($element);
  }, 100);
}

function ensureItemIsSelected($el) {
  if (!$el) return;
  if (!$el.find('.wrapper .selected').length) {
    const currentIdx = store.getState().moSelectedItemIdx || 0;
    $el.find('.items .item').eq(currentIdx).addClass('selected');
  }
}

let ACTIVE = null;
const setActive = active => {
  ACTIVE = active
};
const getActive = () => ACTIVE

function setColumns($el, numColumns, fromApplyToAll = false) {
  const numItems = $el.find('.item').length;
  if (numItems < 2 && (numColumns === 2 || numColumns === 3)) return;
  if (numItems < 3 && numColumns === 3) return;
  const oldNumColumns = $el.attr('data-num-columns') !== undefined ? parseInt($el.attr('data-num-columns')) : 1;
  const currentGap = $el.attr('data-column-gap') !== undefined ? parseInt($el.attr('data-column-gap')) : 0;
  let itemsAttrs = [
    ['display', 'flex'],
    ['flex-direction', 'column'],
    ['flex-wrap', 'wrap'],
    ['column-gap', `${currentGap}em`]
  ]
  itemsAttrs.forEach((pair) => {
    let patch = {type: 'items', key: pair[0], value: `${numColumns !== 1 ? pair[1] : ''}`};
    patchStyles($el, patch, false, false, false);
  })
  const columnGapDistributed = numColumns === 2 ? currentGap / 2 : currentGap / 1.5;
  let itemPatch = {
    type: 'item',
    key: 'width',
    value: `calc(${Math.floor(100 / numColumns)}% - ${columnGapDistributed}em)`
  };
  patchStyles($el, itemPatch, false);

  if (!fromApplyToAll) {
    store.dispatch(actions.updateElementAttribute('numColumns', numColumns));
  }
  $el.attr('data-num-columns', numColumns);

  markAsModified();

  // Reset column widths to equal distribution when changing number of columns
  const equalWidths = Array(numColumns).fill(Math.floor(100 / numColumns));
  setColumnWidths($el, equalWidths);

  util.nextTick(() => {
    if (numColumns === 1) {
      setColumnGap($el, 0);
    } else if ($el.attr('data-column-gap') === undefined || (oldNumColumns === 1 && currentGap === 0)) {
      setColumnGap($el, 2);
    } else {
      fixHeightWithColumns($el);
    }
  }, 100)
}

function setColumnGap($el, columnGap, fromApplyToAll = false) {
  const numColumns = $el.attr('data-num-columns') ? parseInt($el.attr('data-num-columns')) : 1;
  if (numColumns === 1) columnGap = 0;
  if (!fromApplyToAll) {
    store.dispatch(actions.updateElementAttribute('columnGap', columnGap));
  }
  $el.attr('data-column-gap', columnGap);
  let itemsPatch = {type: 'items', key: 'column-gap', value: `${columnGap}em`};
  patchStyles($el, itemsPatch);

  const columnGapDistributed = numColumns === 2 ? columnGap / 2 : columnGap / 1.5;
  let itemPatch = {
      type: 'item',
      key: 'width',
      value: `calc(${Math.floor(100 / numColumns)}% - ${columnGapDistributed}em)`
  };
  patchStyles($el, itemPatch);
  util.nextTick(() => {
    fixHeightWithColumns($el);
    const columnWidths = $el.attr('data-column-widths') ? JSON.parse($el.attr('data-column-widths')) : [];
    setColumnWidths($el, columnWidths);
  }, 100)
}

function setColumnWidths($el, columnWidths, fromApplyToAll = false) {
  const numColumns = $el.attr('data-num-columns') ? parseInt($el.attr('data-num-columns')) : 1;
  let columnGap = $el.attr('data-column-gap') !== undefined ? parseInt($el.attr('data-column-gap')) : 2;

  if (!fromApplyToAll) {
    store.dispatch(actions.updateElementAttribute('columnWidths', columnWidths));
  }
  $el.attr('data-column-widths', JSON.stringify(columnWidths));

  const $items = $el.find('.item');
  const columns = new Array(numColumns).fill().map(() => []);

  // Store initial positions before any changes
  const itemPositions = [];
  $items.each(function(index) {
    const rect = this.getBoundingClientRect();
    itemPositions.push({
      index: index + 1,
      $item: $(this),
      left: rect.left
    });
  });

  // Reset any existing column-specific widths to get natural positioning
  $items.each(function() {
    $(this).css('width', '');
  });

  // Force a reflow to get updated positions
  $el[0].offsetHeight;

  // Get natural column positions
  const xPositions = new Set();
  itemPositions.forEach(({left}) => {
    xPositions.add(Math.round(left));
  });

  const sortedXPositions = Array.from(xPositions).sort((a, b) => a - b);
  //console.log('Detected column positions:', sortedXPositions);

  // Assign items to columns based on their natural position
  itemPositions.forEach(({$item, left, index}) => {
    const roundedLeft = Math.round(left);
    const columnIndex = sortedXPositions.indexOf(roundedLeft);

    //console.log(`Item ${index} - Position:`, roundedLeft, 'Column:', columnIndex + 1);

    if (columnIndex !== -1 && columnIndex < numColumns) {
      columns[columnIndex].push({
        $item,
        index
      });
    }
  });

  /*console.log('\nFinal column assignments:');
  columns.forEach((column, index) => {
    console.log(`Column ${index + 1}:`, column.map(item => item.index));
  });*/

  let perColumnGap = (columnGap * (numColumns - 1)) / numColumns;
  // Apply widths based on column assignments
  columns.forEach((column, columnIndex) => {
    const width = columnWidths[columnIndex];
    //console.log(`\nApplying width ${width}% to column ${columnIndex + 1}`);
    column.forEach(item => {
      let itemPatch = {
        type: `item:nth-child(${item.index})`,
        key: 'width',
        value: `calc(${width}% - ${perColumnGap}em)`
      };
      patchStyles($el, itemPatch);
    });
  });

  util.nextTick(() => {
    fixHeightWithColumns($el);
    setHeights($el);
  }, 100);
}

function fixHeightWithColumns($el) {
  clearPriceBorders($el);
  const numColumns = $el.attr('data-num-columns') ? parseInt($el.attr('data-num-columns')) : 1;
  let returnHeight = 0;

  if (numColumns === 2 || numColumns === 3 || numColumns === 4) {
    let $items = $el.find('.items');
    const spaceBelow = parseFloat($items.find('.item').first().css('margin-bottom'));
    let totalHeight = 0;
    let itemHeights = [];
    $items.find('.item').each(function() {
      const $this = $(this);
      const thisHeight = $this.prop('scrollHeight');
      totalHeight += Math.ceil(thisHeight + spaceBelow);
      itemHeights.push(Math.ceil(thisHeight + spaceBelow));
    })
    let goalHeight = totalHeight / numColumns;

    let heightCounter = 0;
    let itemIndex = 0;
    while (heightCounter + itemHeights[itemIndex] <= goalHeight) {
      heightCounter += itemHeights[itemIndex];
      itemIndex += 1;
    }
    let heightSets = [];
    if (numColumns === 2) {
      let firstColumnOptions = [heightCounter, heightCounter + itemHeights[itemIndex]];
      firstColumnOptions.forEach((firstHeight) => {
        let secondHeight = totalHeight - firstHeight;
        heightSets.push([firstHeight, secondHeight]);
      })
    } else if (numColumns === 3) {
      let firstColumnOptions = [[heightCounter, itemIndex], [heightCounter + itemHeights[itemIndex], itemIndex + 1]];
      firstColumnOptions.forEach((firstColumnInfo) => {
        let heightCounter = 0;
        let itemIndex = firstColumnInfo[1];
        while (heightCounter + itemHeights[itemIndex] <= goalHeight) {
          heightCounter += itemHeights[itemIndex];
          itemIndex += 1;
        }
        heightSets.push([firstColumnInfo[0], heightCounter, totalHeight - firstColumnInfo[0] - heightCounter]);
        heightCounter += itemHeights[itemIndex];
        heightSets.push([firstColumnInfo[0], heightCounter, totalHeight - firstColumnInfo[0] - heightCounter]);
      })
    } else if (numColumns === 4) {
      let firstColumnOptions = [[heightCounter, itemIndex], [heightCounter + itemHeights[itemIndex], itemIndex + 1]];
      firstColumnOptions.forEach((firstColumnInfo) => {
        let heightCounter = 0;
        let itemIndex = firstColumnInfo[1];

        // Calculate second column
        while (heightCounter + itemHeights[itemIndex] <= goalHeight) {
          heightCounter += itemHeights[itemIndex];
          itemIndex += 1;
        }
        let secondColumnOptions = [[heightCounter, itemIndex], [heightCounter + itemHeights[itemIndex], itemIndex + 1]];

        // Calculate third and fourth columns
        secondColumnOptions.forEach((secondColumnInfo) => {
          let thirdHeightCounter = 0;
          let thirdItemIndex = secondColumnInfo[1];

          while (thirdHeightCounter + itemHeights[thirdItemIndex] <= goalHeight) {
            thirdHeightCounter += itemHeights[thirdItemIndex];
            thirdItemIndex += 1;
          }

          // Add height combinations for all 4 columns
          heightSets.push([
            firstColumnInfo[0],
            secondColumnInfo[0],
            thirdHeightCounter,
            totalHeight - firstColumnInfo[0] - secondColumnInfo[0] - thirdHeightCounter
          ]);

          // Try alternative height for third column
          thirdHeightCounter += itemHeights[thirdItemIndex];
          heightSets.push([
            firstColumnInfo[0],
            secondColumnInfo[0],
            thirdHeightCounter,
            totalHeight - firstColumnInfo[0] - secondColumnInfo[0] - thirdHeightCounter
          ]);
        });
      });
    }
    let minAvg = Number.MAX_VALUE;
    let toBeHeight = totalHeight;
    heightSets.forEach((heightSet) => {
      let wouldBeHeight = Math.max.apply(null, heightSet);
      let sum = 0;
      heightSet.forEach((num) => {
        sum += Math.abs(goalHeight - num)
      });
      let avg = sum / heightSet.length;
      if (avg < minAvg) {
        minAvg = avg;
        toBeHeight = wouldBeHeight;
      }
    })
    returnHeight = toBeHeight;
  }

  const moItemsPadding = 22;

  if (util.isSafari()) {
    returnHeight += 5;
  }
  let patch = {type: 'items', key: 'height', value: `${numColumns !== 1 ? returnHeight + moItemsPadding : ''}px`};
  patchStyles($el, patch, false);
  fixPriceBorder($el);
}

function getMenuGroup(id) {
  return $(`.page [data-id='${id}']`);
}

function isGroupOnCanvas(id) {
  return getMenuGroup(id).length > 0;
}

function removeAssociatedToGroup(id) {
  AppRenderer.remove($(`[data-id='${id}']`));
  store.dispatch(actions.deselect());
}

function addMenuItemsTemplateToCanvas(layout, items, cfg) {
  const defaultLayoutConfig = JSON.parse(getFirstMenuItemConfig() || DEFAULT_MO_STYLE);
  const nameLayoutConfig = { ...defaultLayoutConfig.styles.name, "font-size": "110%", "text-transform": "none" };
  const priceLayoutConfig = { ...defaultLayoutConfig.styles.price};
  const tagLayoutConfig = { ...defaultLayoutConfig.styles.tag, "font-size": "100%" };
  const descriptionLayoutConfig = { ...defaultLayoutConfig.styles.description, "font-size": "100%" };
  const binLayoutConfig = { ...defaultLayoutConfig.styles.bin, "font-size": "110%" };
  const binHeaderLayoutConfig = { ...defaultLayoutConfig.styles['bin-header'], "font-size": "110%" };
  const moNameLayoutConfig = { ...defaultLayoutConfig.styles['mo-name'], "padding": getDefaultMONamePadding()};
  const moNotesLayoutConfig = { ...defaultLayoutConfig.styles['mo-notes'], "padding": getDefaultMONotesPadding()};

  const mo = new designDomain.MenuObject({
    config: JSON.stringify({ ...defaultLayoutConfig, styles: {
      ...defaultLayoutConfig.styles,
      name: nameLayoutConfig,
      tag: tagLayoutConfig,
      description: descriptionLayoutConfig,
      price: priceLayoutConfig,
      bin: binLayoutConfig,
      'bin-header': binHeaderLayoutConfig,
      'mo-name': moNameLayoutConfig,
      'mo-notes': moNotesLayoutConfig,
    }, layout: layout }),
    content: JSON.stringify(items)
  });

  const html = getHtmlContent(mo.content, mo.config);
  const $page = util.getPageInViewport($('.page'));

  const compId = addComponent($page.attr('id'), html, cfg || {
    position: {
      left: VIEWPORT_CENTER,
      top: VIEWPORT_CENTER
    },
    isFromTemplate: true,
    keepColors: true
  });

  if (layout.indexOf('-with-dot-leaders') > -1) {
    setTimeout(() => {
      const $el = $(`#${compId}`);
      updateDots($el, true);
      fixDots($el);
    }, 100);
  }

  return compId;
}

function singleMenuIconColorChange(iconKey, color, exludeId) {
  $('[data-component="menu-object"]').each(function() {
    const $menuObject = $(this);
      const theseItems = getMenuItems($menuObject);
      let updated = false;
      theseItems.forEach(item => {
        item.icons.forEach(icon => {
            if (icon.iconKey === iconKey) {
                icon.fill = color;
                updated = true;
            }
        })
      });
      if (updated) {
        updateContent($menuObject, theseItems, false, true);
      }
  })
}

function findMenuActiveIcons() {
  let activeIcons = [];
  $('.pages .page .content div[data-component="menu-object"]').each(function() {
    const items = getMenuItemIcons($(this));
    items.forEach(item => {
      item.icons.forEach(icon => {
        if (!activeIcons.map(i => { return i.iconKey }).includes(icon.iconKey)) {
          activeIcons.push(icon);
        }
      })
    })
  })
  store.dispatch(actions.setMenuActiveIcons(activeIcons));
}

function removeIndividualIconColors() {
  $('[data-component="menu-object"]').each(function() {
    const $menuObject = $(this);
    const theseItems = getMenuItems($menuObject);
    theseItems.forEach(item => {
      item.icons.forEach(icon => {
        icon.fill = '';
      })
    });
    updateContent($menuObject, theseItems, false, true);
  })
}

function markConfigsUntranslatable() {
  $('[data-component="menu-object"] .config').each(function() {
    $(this).attr('translate', 'no');
  })
}

function checkPosDataUsage() {
  const $toast = $("[data-source='toast']");
  const $square = $("[data-source='square']");
  store.dispatch(actions.setHasPosData($toast.length > 0 || $square.length > 0));
}

function applyNameStylesToBin($object) {
  const styles = getStyles($object);
  if (styles['bin'] && styles['bin-header']) return;
  styles['bin'] = {};
  styles['bin-header'] = {};
  ['font-size', 'font-family', 'font-weight', 'color', 'line-height'].forEach(attr => {
    if (styles.name[attr]) {
      styles['bin'][attr] = styles.name[attr];
      styles['bin-header'][attr] = styles.name[attr];
    }
  })
  overwriteStyles($object, styles, false);
  store.dispatch(actions.setMenuObjectStyles(styles));
}

function updateModifierDivider($element, char) {
  if ($element.attr('data-modifier-layout') === 'stacked') {
    char = '';
  }
  const entryCSS = 'modifier-entry:not(:last-child)::after';
  const styles = getStyles($element);
  const modNameColor = styles[MODIFIERENTRYNAME] && styles[MODIFIERENTRYNAME]['color'] ? styles[MODIFIERENTRYNAME]['color'] : '#333';
  const modNameSize = styles[MODIFIERENTRYNAME] && styles[MODIFIERENTRYNAME]['font-size'] ? styles[MODIFIERENTRYNAME]['font-size'] : '';
  const modNameLineHeight = styles[MODIFIERENTRYNAME] && styles[MODIFIERENTRYNAME]['line-height'] ? styles[MODIFIERENTRYNAME]['line-height'] : '';
  const dividerMargin = '0.5em';
  let patches = [
    { type: entryCSS, key: 'content', value: char ? `"\\${char}"` : '' },
    { type: entryCSS, key: 'position', value: 'relative' },
    { type: entryCSS, key: 'display', value: 'inline-block' },
    /*{ type: entryCSS, key: 'right', value: `-${dividerMargin}` },
    { type: entryCSS, key: 'bottom', value: '0' },*/
    { type: entryCSS, key: 'width', value: 'fit-content' },
    { type: entryCSS, key: 'margin-left', value: dividerMargin },
    { type: entryCSS, key: 'text-align', value: `center` },
    { type: entryCSS, key: 'font-size', value: modNameSize },
    { type: entryCSS, key: 'line-height', value: modNameLineHeight },
    { type: entryCSS, key: 'color', value: modNameColor },
  ]
  patches.forEach(patch => {
    patchStyles($element, patch, false, false);
  })
  $element.attr('data-modifier-divider', char);
}

function updatePriceDivider($element, char) {
  const styles = getStyles($element);
  const layout = $element.attr('data-layout');
  let priceMargin = '0.5em';
  if (styles['price-entry'] && styles['price-entry']['margin-right']) {
    priceMargin = styles['price-entry']['margin-right'];
  }
  let patches = [
    { type: 'price-entry:not(.last)::after', key: 'content', value: char ? `"\\${char}"` : '' },
    { type: 'price-entry:not(.last)::after', key: 'position', value: 'absolute' },
    { type: 'price-entry:not(.last)::after', key: 'right', value: `-${priceMargin}` },
    { type: 'price-entry:not(.last)::after', key: 'width', value: `${priceMargin}` },
    { type: 'price-entry:not(.last)::after', key: 'bottom', value: bottomAlignPriceColumnLayouts.includes(layout) ? 0 : '' }
  ]
  patches.forEach(patch => {
    patchStyles($element, patch, false, false);
  })
  $element.attr('data-price-divider', char);
}

function getNumPrices(items) {
  let numPrices = 0;
  items.forEach(it => {
    if (it.prices && it.prices.length && it.prices.length > numPrices) {
      numPrices = it.prices.length;
    }
  })
  return numPrices;
}

function storeDeprecatedLayouts() {
  const deprecatedStandardLayouts = ['price-list-compact', 'price-list', 'after-description-price-list'];
  const activeLayouts = getActiveLayouts();
  activeLayouts.forEach(layout => {
    if (deprecatedStandardLayouts.includes(layout)) {
      if ($('#design-cfg').length > 0) {
        $('#design-cfg').attr('deprecated-layout', layout);
      } else {
        $('.pages').append(`<div id="design-cfg" style="display: none;" deprecated-layout="${layout}"></div>`);
      }
    }
  });
}

function startApplyToMoMode($element, applyMode) {
  removeMenuObjectPlaceholders();
  store.dispatch(actions.setApplyToMoInProgress(true));
  $('.menu-object').each(function() {
    const $this = $(this);
    if ($this.attr('id') !== $element.attr('id') || applyMode === applyModes.highlightStyle) {
      $this.append('<div class=\'menu-object-apply-placeholder\'></div>');
    }
  })
  $('.menu-object').addClass('placeholder-mode');
  $('.page > .content').prepend('<div class=\'page-menu-object-placeholder\'></div>');

  $('.menu-object-apply-placeholder').on('click', function (ev) {
    ev.stopPropagation();
    const $overlay = $(this);
    const $mo = $overlay.parent();
    if (!applyMode || applyMode === applyModes.columns) {
      applyLayoutToAll($element, applyMode);
    } else {
      applyToAll($element, applyMode, $mo);
    }
    $overlay.remove();

    const remainingPlaceholders = $('.menu-object-apply-placeholder').length;
    if (remainingPlaceholders === 0) {
      removeMenuObjectPlaceholders();
      store.dispatch(actions.setApplyToMoInProgress(false));
    }
  });

  $('.page-menu-object-placeholder').on('click', function (ev) {
    ev.stopPropagation();
    removeMenuObjectPlaceholders();
    store.dispatch(actions.setApplyToMoInProgress(false));
  });
}

function fixNameNotesPadding($element) {
  let $name = $element.find('.mo-name');
  if ($name.length) {
    patchStyles($element, {
      type: 'mo-name',
      key: 'padding',
      value: getDefaultMONamePadding()
    })
  }

  let $notes = $element.find('.mo-notes');
  if ($notes.length) {
    patchStyles($element, {
      type: 'mo-notes',
      key: 'padding',
      value: getDefaultMONotesPadding()
    })
  }
}

function updatePriceBorder($element, priceBorderOn = null, priceBorderDouble = null) {
  if (priceBorderOn === null) {
    priceBorderOn = $element.attr('data-price-border') && $element.attr('data-price-border') !== 'none';
  }
  if (priceBorderDouble === null) {
    priceBorderDouble = $element.attr('data-price-border') === 'double';
  }

  clearPriceBorders($element);
  let patches = [];
  if (priceBorderOn) {
    const styles = getStyles($element);
    const typeString = 'item .right::before';
    const borderWidthCSS = styles['mo-content'] && styles['mo-content']['border'] ? styles['mo-content']['border'].split(' ')[0] : '.1em';
    const borderWidth = parseFloat(borderWidthCSS) * 10 || 1;
    const borderColor = util.getMOBorderColor($element);
    const borderGap = 1;
    const belowItems = styles['item'] && styles['item']['margin-bottom'] ? parseFloat(styles['item']['margin-bottom']) : 0;
    const moHeight = $element.find('.items').css('height');
    const pricesHidden = $element.attr('data-hide-prices') ? $element.attr('data-hide-prices') === "true" : false;

    patches = [
      { type: 'right', key: 'position', value: 'relative' },
      { type: typeString, key: 'content', value: `' '` },
      { type: typeString, key: 'width', value: '0' },
      { type: typeString, key: 'position', value: 'absolute' },
      { type: typeString, key: 'margin-left', value: '-4px' },
      { type: typeString, key: 'height', value: `calc(100% + ${belowItems}em + 1px)` },
      { type: typeString, key: 'top', value: `0` },
      { type: typeString, key: 'z-index', value: '1' },
    ];

    patches.push(
      { type: 'item:last-child .right::before', key: 'height', value: moHeight }
    )

    if (pricesHidden) {
      patches.push({ type: typeString, key: 'opacity', value: '0' });
    } else {
      patches.push({ type: typeString, key: 'opacity', value: '1' });
    }

    if (priceBorderDouble) {
      patches.push(
        { type: typeString, key: 'box-shadow', value: `-${borderWidth+1}px 0px 0px 0px ${borderColor}` },
        { type: typeString, key: 'border-right', value: `${borderWidth}px solid ${borderColor}` }
      );
    } else {
      patches.push(
        { type: typeString, key: 'border-right', value: `${borderWidth}px solid ${borderColor}` },
        { type: typeString, key: 'box-shadow', value: 'none' }
      );
    }

    const $items = $element.find('.item');
    const highlightPadding = 5;
    const hasName = $element.find('.mo-name').length > 0;
    const hasNotes = $element.find('.mo-notes').length > 0;
    const firstItemTop = $items.first().offset().top;
    let elIndex = 1;
    let prevTop = firstItemTop;

    $items.each(function() {
      const $this = $(this);
      const typeString = `item:nth-child(${elIndex}) .right::before`;
      const thisTop = $this.offset().top;
      const isAtTop = thisTop === firstItemTop;
      const hasHighlight = $this.hasClass('highlighted');
      let topString = '0px';
      let heightString = `100% + 1px + ${belowItems}em`;

      if (hasHighlight) {
        topString += ` - ${highlightPadding}px`;
        heightString += ` + ${highlightPadding*2}px`;
      }

      if (isAtTop) {
        topString += ` - 1em`;
        heightString += ` + 1em`;

        if (hasNotes) {
          if (styles['mo-notes'] && styles['mo-notes']['margin-bottom']) {
            const notesBottom = parseFloat(styles['mo-notes']['margin-bottom']);
            const marginInPx = parseFloat($('#page-1').css('font-size')) * notesBottom * (parseFloat(styles['mo-notes']['font-size'])/100);
            topString += ` - ${marginInPx}px`;
            heightString += ` + ${marginInPx}px`;
          }
        } else if (hasName) {
          if (styles['mo-name'] && styles['mo-name']['margin-bottom']) {
            const nameBottom = parseFloat(styles['mo-name']['margin-bottom']);
            const marginInPx = parseFloat($('#page-1').css('font-size')) * nameBottom * (parseFloat(styles['mo-name']['font-size'])/100);
            topString += ` - ${marginInPx}px`;
            heightString += ` + ${marginInPx}px`;
          }
        }
      }

      if (hasHighlight || isAtTop) {
        patches.push(
          { type: typeString, key: 'top', value: topString === '0px' ? 0 : `calc(${topString})` },
          { type: typeString, key: 'height', value: `calc(${heightString})` },
        )
      }

      if (thisTop <= prevTop && elIndex !== 1) {
        const typeString = `item:nth-child(${elIndex-1}) .right::before`;
        patches.push(
          { type: typeString, key: 'height', value: moHeight }
        )
      }
      elIndex += 1;
      prevTop = thisTop;
    })

    patches.forEach(patch => {
      //patchStyles($element, patch, false, true, false);
      if (!styles[patch.type]) {
        styles[patch.type] = {};
      }
      styles[patch.type][patch.key] = patch.value;
    })
    overwriteStyles($element, styles, false);
  }
}

function clearPriceBorders($element) {
  const styles = getStyles($element);
  Object.keys(styles).forEach(key => {
    if (key.includes('right::before')) {
      delete styles[key];
    }
  })
  overwriteStyles($element, styles, false);
}

function fixPriceBorder($element) {
  if ($element.attr('data-price-border') && $element.attr('data-price-border') !== 'none') {
    updatePriceBorder($element);
  } else {
    clearPriceBorders($element);
  }
}

function applyLetterIconDefaultStyles($element) {
  const styles = getStyles($element);
  if (styles[ICON_ENTRY] && styles[ICON_ENTRY]['font-family']) return;
  if (!styles[ICON_ENTRY]) {
    styles[ICON_ENTRY] = {};
  }
  letterIconStyleAttrs.forEach(attr => {
    if (styles[NAME][attr]) {
      styles[ICON_ENTRY][attr] = styles[NAME][attr];
    }
  });
  styles[ICON_ENTRY]['text-align'] = 'center';
  overwriteStyles($element, styles, false);
}

function fixDefaultIconColor() {
  const $menuObjects = $('#pages').find('.menu-object[data-component="menu-object"]');
  $menuObjects.each(function() {
    const $this = $(this);
    const styles = getStyles($this);
    if (!styles[ICON_ENTRY]) {
      styles[ICON_ENTRY] = {};
    }
    if (styles[NAME]['color']) {
      styles[ICON_ENTRY]['color'] = styles[NAME]['color'];
    }
    overwriteStyles($this, styles, false);
  })
}

export default {
  addMenuItemsTemplateToCanvas,

  isGroupOnCanvas,
  getMenuGroup,
  removeAssociatedToGroup,
  getRatio,
  adaptEventToZoom,
  ensureKidsHeight,
  isMenuObject,
  getSelectBar,
  getSelectionState,

  getHtmlContent,
  getHtmlItems,
  getMenuItems,
  getFirstMenuItemConfig,
  getStyles,

  applyModes,
  applyLayoutToAll,
  applyToAll,

  ensureIds,
  refreshStyles,
  patchStyles,
  updateStateItems,
  updateMOName,
  updateMONotes,
  deleteMOName,
  deleteMONotes,
  updateContent,
  fullyReplaceContent,
  updateLayout,
  ensureHasWrapper,
  updateIconLayout,
  updateIconsInDescription,
  updateIconPosition,
  updateShowMenuTag,
  updateShowModifiers,
  updateModifierLayout,
  updateModifierDivider,
  updateHidePrices,
  updateHideTrailingZeroes,
  updateInlineExtras,
  updateMenuTagLayout,
  setHeights,
  applyLetterIconDefaultStyles,
  fixDefaultIconColor,

  fixLayouts,

  MenuItem,
  MenuIcon,
  MenuObjectName,
  MenuObjectNotes,

  MENU_OBJECT,

  setActive,
  getActive,
  ACTIVE,
  fixLineHeights,
  resetLineHeightsStandalone,

  getActiveLayouts,

  DEFAULT_MO_STYLE,

  updateDots,
  fixDots,
  moPaginationPrev,
  moPaginationNext,
  moPaginationDelete,
  moAddItem,
  ensureItemIsSelected,

  getDefaultMONamePadding,
  getDefaultMONotesPadding,
  fixNameNotesPadding,

  setColumns,
  setColumnGap,
  setColumnWidths,
  fixHeightWithColumns,
  updatePriceBorder,
  fixPriceBorder,

  singleMenuIconColorChange,
  findMenuActiveIcons,
  markConfigsUntranslatable,
  checkPosDataUsage,
  applyNameStylesToBin,
  updatePriceDivider,
  getNumPrices,
  convertMenuObjectPriceStyles,
  addMenuObjectDefaultModifierStyles,
  convertMenuItemHighlightIds,
  rerenderForModifiers,
  storeDeprecatedLayouts,

  startApplyToMoMode,

  spellCheck
};
